<template>
	<div>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text" :class="{'two-line-title':Form.transactionTypeList && Form.transactionTypeList.length>1}">
		    	{{toolbarTitle}}
		    	<div class="toolbar-subtitle" @click="fn_openTransactionTypeList" v-if="Form.transactionTypeList && Form.transactionTypeList.length>1">
		    		<div class="subtitle-text dark-opacity-color">{{Form.transactionTypeFormName ? Form.transactionTypeFormName : 'Select Transaction Form'}}</div>
		    		<v-icon class="subtitle-icon">arrow_drop_down</v-icon>
		    	</div>
		    </v-toolbar-title>
			<!-- <div>
		    	<div style="float: left;margin-right: 12px;margin-top: 6px;color: rgba(0,0,0,0.57);">Cash Expense</div>
		    	<v-switch class="hide-margins" hide-details v-model="Form.isCashTransaction" @change="fn_byCash"></v-switch>
		    </div> -->
		</v-toolbar>

		<div class="hasToolbar" v-if="loading">
			<v-progress-linear height="4" nomargin indeterminate color="primary"></v-progress-linear>	
		</div>

		<v-form class="form-element hasToolbar hasBigFooter grey-back" v-else>

			<v-alert style="height:42px" :value="true" color="warning pt-0 pb-0 pr-0" transition="slide-y-transition" v-if="transactionCount>=1">
              <v-layout row wrap style="align-items:center">
                <v-flex xs8 sm8 md8><v-icon class="font20 whitecolor mr-2">error_outline</v-icon> Set Auto Data Backup</v-flex>
                <v-flex xs4 sm4 md4 right-align>
                  <v-btn style="color:#fff" capitalize flat small @click="fn_gotoSetupDrive">Setup Now</v-btn>
                </v-flex>
              </v-layout>
            </v-alert>

			<div class="form_wrapper" v-if="!loading">

				<v-layout row wrap>
            	  <v-list full-width nopadding>
					  	<v-list-tile>
				          	<v-list-tile-content @click="fn_openDialogNumberSeries">
				              <!-- <v-list-tile-title>{{transactionNumber}}</v-list-tile-title> -->
				              <v-list-tile-title class="merged_tnumber">{{Form.transactionData.mergeTransactionNumber}}</v-list-tile-title>
				            </v-list-tile-content>

				            <span>{{Form.transactionData.transactionDate | moment("DD-MMM-YYYY")}}</span>	

				            <v-list-tile-action class="action-small">
	            				<v-btn flat icon color="primary" @click="fn_openDatePicker('transactionDate', Form.transactionData.transactionDate)" class="no-left-margin">
	            					<v-icon>date_range</v-icon>	
	            				</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>
            	</v-layout>

				<!-- <v-layout row wrap margin-top-ten white-background padding-top-bottom-ten id="supplierfield" v-if="!Form.isCashTransaction"> -->
				<v-layout row wrap margin-top-ten white-background padding-top-bottom-ten id="supplierfield">

		        	<v-flex xs12 sm12 md12 form-item @click="fn_openSuppliers">
		               <v-text-field  
			               	readonly
							:disabled="Form.isCashTransaction"
			               	:hide-details="Form.partyName ? true : false"
			               	v-model="Form.partyName" 
			               	:label="fn_partyLabel()"
			               	:onUpdate="fn_updateSupplier" 
			               	:placeholder="Form.isCashTransaction ? 'Not applicable' : ' '" 
			               	append-icon="arrow_drop_down"
			               	ref="ref_fieldSupplier"
			               	v-validate="'required'"
		               		data-vv-name="supplier" 
		               		:error-messages="errors.collect('supplier')"
		               		required>
		               </v-text-field>
		            </v-flex>

		            <v-flex right-align xs12 sm12 md12 pl-3 pr-3 pb-2 pt-1 font12 v-if="Form.partyName && Form.partyDetails">
		               <!-- <span light-opacity-color>Balance:</span> -->
					   <span light-opacity-color>{{ fn_balanceLabel(Form.partyDetails) }}</span>
					   <span :class="[Form.partyDetails.balance < 0 ? 'redcolor' : 'greencolor']">&#8377; {{$root.numberToLocale(Form.partyDetails.balance)}}</span>
		            </v-flex>

		            <!-- <v-flex xs12 sm12 md12 form-item>
		            	RCM Applicable
			           	<v-radio-group v-model="Form.isRcmApplicable" row>
					      <v-radio label="No" :value="0"></v-radio>
					      <v-radio label="Yes" :value="1"></v-radio>
					    </v-radio-group>
			        </v-flex> -->

		            <v-flex xs12 sm12 md12 form-item @click="fn_openStates" v-if="$root.CurrentBusiness.GSTRegistrationStatus==1 && Form.partyDetails && Form.partyDetails.gstType!=105 && !Form.isCashTransaction">
		               <v-text-field  
			               	readonly
			               	v-model="Form.placeOfSupplyName" 
			               	label="State/Place of Supply"
			               	:onUpdate="fn_updateState" 
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
			               	ref="ref_fieldState">
		               </v-text-field>
		            </v-flex>

					<v-flex xs12 sm12 md12 form-item>
						<v-checkbox label="Supplier not applicable" v-model="Form.isCashTransaction" @change="fn_byCash"></v-checkbox>
					</v-flex>

		        </v-layout>

				<!-- <v-flex xs12 sm12 md12 form-item @click="fn_openGodowns('android', 'Godowns', 'ref_fieldGodown')" v-if="$root.TransactionSettings.enableGodown">
					<v-text-field  
						readonly
						v-model="Form.godownName" 
						label="Select Godown"
						:onUpdate="fn_updateGodown" 
						ref="ref_fieldGodown"
						placeholder=" " 
						append-icon="arrow_drop_down"
						required>
					</v-text-field>
				</v-flex> -->

		       <!--  <v-layout pt-3 row wrap white-background margin-top-ten v-if="$root.CurrentBusiness.GSTRegistrationStatus==1">
            	  	<v-flex xs12 sm12 md12 form-item>
		            	<v-checkbox :disabled="Form.taxMode==0" class="nomargin" v-model="Form.isRcmApplicable" label="RCM Applicable"></v-checkbox>
		            </v-flex>
            	</v-layout> -->

		        <v-layout row wrap margin-top-ten white-background>

		        	<div white-background full-width class="small-textbox-container">
						<v-layout row wrap class="layout-wrap">
						  <v-flex xs6 sm6 md6 pl-3 class="small-textbox-label">             
						     <div>Bill Number</div>
						  </v-flex>
						  <v-flex xs6 sm6 md6 pr-3 class="small-textbox">
						    <v-text-field 
						    	v-model="Form.transactionData.refNumber" 
						    	label="" >
						    </v-text-field>
						  </v-flex>
						</v-layout>
					</div>

		        	<v-list full-width nopadding>

					    <v-list-tile>
				          	<v-list-tile-content>
				          		<v-list-tile-title>Bill Date</v-list-tile-title>
				            </v-list-tile-content>
				            <span v-if="Form.transactionData.refDate">{{Form.transactionData.refDate | moment("DD-MMM-YYYY")}}</span>
				            <v-list-tile-action class="action-small">
				            	<v-btn flat icon color="primary" @click="fn_openDatePicker('refDate', Form.transactionData.refDate)" class="no-left-margin">
	            					<v-icon>date_range</v-icon>	
	            				</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>

		        </v-layout>

		        <v-layout margin-top-ten row wrap white-background v-if="$root.CurrentBusiness.GSTRegistrationStatus!=3 && !Form.isCashTransaction">
				<!-- <v-layout margin-top-ten row wrap white-background v-if="fn_checkIfTaxApplicable()"> -->

		        	<v-subheader full-width font16 medium-theme-color font-normal border-bottom-thin>
		        		Tax 
		        		<!-- <v-spacer></v-spacer>
		        		<v-checkbox right-align-checkbox hide-details :disabled="Form.taxMode==0" class="nomargin tile-checkbox-align-right" v-model="Form.isRcmApplicable" label="RCM Applicable"></v-checkbox> -->
		        	</v-subheader>
		        	<v-divider></v-divider>
		          	<v-flex xs12 sm12 md12 form-item>
		               	<v-radio-group class="pb-3" :hide-details="true" v-model="Form.taxMode" row @change="fn_calculateTax(true)">
					      <v-radio label="None" :value="0" ></v-radio>
					      <v-radio label="Exclusive" :value="1"></v-radio>
					      <v-radio label="Inclusive" :value="2"></v-radio>
					    </v-radio-group>
		            </v-flex>

		            <template v-if="Form.taxMode">
		            	<v-flex xs6 sm6 md6 pl-3 pr-1 v-if="$root.CurrentBusiness.GSTRegistrationStatus==1">
			            	<v-checkbox label="ITC Eligible" v-model="Form.isItcEligible" @change="fn_itcEligible"></v-checkbox>
			            </v-flex>

			            <v-flex xs6 sm6 md6 pl-3 pr-3 v-if="$root.CurrentBusiness.GSTRegistrationStatus==1">
			            	<v-checkbox label="RCM Applicable" v-model="Form.isRcmApplicable" @change="fn_calculateTax(false)"></v-checkbox>
			            </v-flex>
		            </template>

		            <!-- <v-list nopadding v-if="Form.taxMode">
		            	<v-list-tile>
							<v-list-tile-action style="margin-right:-16px">
								<v-checkbox @change="fn_itcEligible" v-model="Form.isItcEligible" style="width: 32px;float:left"></v-checkbox>
							</v-list-tile-action>
						  	<v-list-tile-content>
						    	<v-list-tile-title>ITC Eligible</v-list-tile-title>
						  	</v-list-tile-content>
						</v-list-tile>
		            </v-list> -->

		        </v-layout>

		        <v-layout row wrap white-background margin-top-ten padding-top-bottom-ten>
		        	
		        	<!-- <v-flex xs12 sm12 md12 form-item align-msg-right @click="fn_openExpenseLedgers">
			        	<v-text-field  
			        		readonly
			        		persistent-hint
		               		v-model="Form.expenseData.accountLedgerName" 
		               		label="Expense Ledger" 
		               		placeholder=" "
		               		append-icon="arrow_drop_down"
		               		ref="ref_expenseLedger" 
			               	:onUpdate="fn_updateExpenseLedger"
			               	v-validate="'required'" 
		               		data-vv-name="expenseLedger" 
		               		data-vv-as="expense ledger" 
		               		:error-messages="errors.collect('expenseLedger')">
		               	</v-text-field>
		            </v-flex> -->
		            <v-flex xs12 sm12 md12 form-item align-msg-right @click="fn_openExpenseCategories('android', 'Expense Category', 'ref_expenseCategory')">
			        	<v-text-field  
			        		readonly
			        		persistent-hint
		               		v-model="Form.expenseCategoryName" 
		               		label="Expense Category" 
		               		placeholder=" "
		               		append-icon="arrow_drop_down"
		               		ref="ref_expenseCategory" 
			               	:onUpdate="fn_updateExpenseCategory"
			               	v-validate="'required'" 
		               		data-vv-name="expenseCategory" 
		               		data-vv-as="expense category" 
		               		:error-messages="errors.collect('expenseCategory')">
		               	</v-text-field>
		            </v-flex>

		            <!-- <v-flex xs12 sm12 md12 form-item v-if="!Form.inventory">
		               <v-text-field 
		               		id="amount_field" 
		               		v-model.number="Form.expenseData.amount" 
		               		type="number" 
		               		 
		               		label="Net Amount" 
		               		placeholder=" "
		               		v-validate="'required|min_value:0|decimal:2'" 
		               		data-vv-name="amount" 
		               		:error-messages="errors.collect('amount')">
		               			
		               	</v-text-field>
		            </v-flex> -->

		        </v-layout>

	        	<v-list margin-top-ten nopadding auto-height-tile>

	        		<v-list-tile>
			          	<v-list-tile-content>
			              <v-list-tile-title medium-theme-color>Item</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
            				<!-- <v-btn flat small color="primary" justify-content-to-end nomargin :ripple="false" @click="fn_addItem(true)">Add</v-btn> -->
							<v-btn small flat outline capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="fn_addItem(true)">
								<v-icon class="mr-1" font16 color="primary">add</v-icon> Item
							</v-btn>
			            </v-list-tile-action>
				    </v-list-tile>
	        				
    				<!-- <v-subheader norightpadding>Items 
	        			<v-spacer></v-spacer>
	        			<v-btn flat small color="primary" justify-content-to-end :ripple="false" @click="fn_addItem(true)">Add</v-btn>
	        		</v-subheader> -->

	        		<v-divider></v-divider>
        			
        			<div v-for="(item, itemIndex) in Form.items" :key="itemIndex">

						<v-list-tile class="right-subtitle-tile custom-action-tile">
						    <v-list-tile-content @click="fn_editItem(item)">
						      <v-list-tile-title class="mb-1">{{item.productName}}</v-list-tile-title>
						      <!-- <v-list-tile-sub-title class="mb-1"><span class="right_subtitle">&#8377; {{$root.numberToLocale(item.netAmount)}}</span> </v-list-tile-sub-title> -->

						      <v-list-tile-sub-title class="mb-1" v-for="(variant, vIndex) in item.productVariants" :key="vIndex" v-if="variant.qty">
						      	{{variant.qty}} {{variant.unitName}} X {{item.rate}}
						      	<!-- <span v-if="variant.packQuantity">({{variant.packQuantity}})</span> X {{item.rate}} -->
						      </v-list-tile-sub-title>

						      <v-list-tile-sub-title class="mb-1" v-for="(addOns, addOnsIndex) in item.addOnsItems" :key="vIndex" v-if="addOns.value && !addOns.isGst">
						      	{{addOns.name}}
						      	<span v-if="addOns.percentage"> @{{addOns.percentage}}%</span>: {{addOns.nature ? '-' : ''}}{{$root.numberToLocale(addOns.value)}}
						      </v-list-tile-sub-title>

						      <v-list-tile-sub-title class="mb-1" v-if="Form.taxMode && item.taxValue!=null">
						      	GST @{{item.taxValue}}%: {{$root.numberToLocale(item.taxAmount)}} {{Form.isRcmApplicable ? ' (RCM)' : ''}}
						      </v-list-tile-sub-title>

						      <v-list-tile-sub-title class="mb-1" v-if="Form.taxMode && item.cessAmount">
						      	Cess<span v-if="item.cessValue!=null"> @{{item.cessValue}}%</span>: {{$root.numberToLocale(item.cessAmount)}} {{Form.isRcmApplicable ? ' (RCM)' : ''}}
						      </v-list-tile-sub-title>

						      <v-list-tile-sub-title class="mb-1" v-if="item.description">
						      	{{item.description}}
						      </v-list-tile-sub-title>

						    </v-list-tile-content>

						    <v-list-tile-action>
						    	&#8377; {{$root.numberToLocale(item.netAmount)}}
						    	<!-- <div v-if="Form.isRcmApplicable">
						    		&#8377; {{$root.numberToLocale(item.netAmount - item.taxAmount - item.cessAmount)}}
						    	</div>
						    	<div v-else>&#8377; {{$root.numberToLocale(item.netAmount)}}</div> -->

						    	<v-btn class="remove_btn" icon @click="fn_removeItem(itemIndex)">
							      	<v-icon class="redcolor">remove_circle_outline</v-icon>
							    </v-btn>
					               <!-- <v-menu bottom left>

								      <v-btn slot="activator" icon>
								      	<v-icon>more_vert</v-icon>
								      </v-btn>

								      <v-list nopadding>
								        <v-list-tile @click="fn_removeItem(itemIndex)">
								          <v-list-tile-title>Remove</v-list-tile-title>
								        </v-list-tile>
								      </v-list>

								    </v-menu> -->
					            </v-list-tile-action>
						</v-list-tile>

						<v-divider v-if="Form.items.length-1 != itemIndex"></v-divider>

					</div>

				</v-list>

				<v-divider v-if="Form.items.length"></v-divider>

				<v-list class="oneline-tile-dense" nopadding v-if="Form.items.length">

					<!-- <v-list-tile v-if="Form.itemsSummary.itemsQuanity.length">
					  <v-list-tile-content>
					    <v-list-tile-title>Total Qty</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action>
					  	<span v-for="(item, index) in Form.itemsSummary.itemsQuanity" v-if="item.qty" :key="index">
					  		{{totalQty}} Units
	               		</span>
					  </v-list-tile-action>
					</v-list-tile> -->

					<v-list-tile v-if="Form.items.length && fn_getTotalQty()">
					  <v-list-tile-content>
					    <v-list-tile-title>Total Qty</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action>{{fn_getTotalQty()}}</v-list-tile-action>
					</v-list-tile>

					<v-list-tile>
					  <v-list-tile-content>
					    <!-- <v-list-tile-title>Gross Amount</v-list-tile-title> -->
					    <v-list-tile-title>Items Total</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action>{{$root.numberToLocale(Form.itemsSummary.grossAmount)}}</v-list-tile-action>
					</v-list-tile>

					<v-list-tile v-for="(item, index) in Form.itemsSummary.addOnsItems" :key="index" v-if="item.value!==null && item.value!==''">
					  <v-list-tile-content>
					    <v-list-tile-title>{{item.nature ? 'Items Discount' : item.name}}</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action>{{item.nature ? '-' : ''}}{{$root.numberToLocale(item.value)}}</v-list-tile-action>
					</v-list-tile>

					<div v-if="Form.taxMode && Form.items.length">
						<!-- When dealing within state -->
						<div v-if="Form.gstType=='IntraState'">
							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>CGST{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.taxValue/2))}}</v-list-tile-action>
							</v-list-tile>
 	
							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>SGST{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.taxValue/2))}}</v-list-tile-action>
							</v-list-tile>
						</div>

						<!-- When dealing with other state -->
						<div v-if="Form.gstType=='InterState'">
							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>IGST{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.taxValue))}}</v-list-tile-action>
							</v-list-tile>
						</div>

						<!-- When dealing from union territory to other state -->
						<div v-if="Form.gstType=='UnionTerritory'">
							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>CGST{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.taxValue/2))}}</v-list-tile-action>
							</v-list-tile>

							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>UTGST{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.taxValue/2))}}</v-list-tile-action>
							</v-list-tile>
						</div>

						<!-- When Cess is applicable -->
						<div v-if="Form.itemsSummary.cessValue">
							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>Cess{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.cessValue))}}</v-list-tile-action>
							</v-list-tile>
						</div>
					</div>

					<!-- <v-divider></v-divider>

					<v-list-tile>
					  <v-list-tile-content>
					    <v-list-tile-title>Net Amount</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action>&#8377; {{$root.numberToLocale(netAmount)}}</v-list-tile-action>
					</v-list-tile> -->
				</v-list>

				<!-- <v-divider v-if="Form.items.length"></v-divider> -->
				<v-list nopadding :class="{'margin-top-ten':!Form.items.length}">

					<!-- <v-list-tile big-height-tile v-if="!Form.items.length && !Form.inventory"> -->
					<v-list-tile big-height-tile v-if="!Form.items.length">
						<v-list-tile-content>
							<v-list-tile-title>Net Amount</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action style="width:40%">
							<!-- <v-text-field right-align name="name" prefix="₹" type="number" v-model.number="Form.expenseData.amount"></v-text-field> -->
							<v-text-field right-align name="name" prefix="₹" type="number" @input="$root.fn_boundDecimalLengthUpto2(Form.expenseData, 'amount')" v-model.number="Form.expenseData.amount"></v-text-field>
						</v-list-tile-action>
					</v-list-tile>

				  	<v-list-tile v-if="Form.items.length">
					  <v-list-tile-content>
					    <v-list-tile-title>Net Amount</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action>&#8377; {{$root.numberToLocale(netAmount)}}</v-list-tile-action>
					</v-list-tile>

				</v-list>

				<v-layout class="descrition-field" pt-3 pb-2 row wrap white-background v-if="!Form.items.length && roundedAmount">
					<!-- <v-flex mb-1 font12 light-theme-color xs12 sm12 md12 form-item>Description</v-flex> -->
					<v-flex xs12 sm12 md12 form-item>
						<v-textarea
							v-validate="'max:255'"
							data-vv-name="description" 
							:error-messages="errors.collect('description')"
							v-model="Form.description"
							label="Description"
							placeholder=" "
							rows="2"
							:counter="255">
						</v-textarea>
					</v-flex>
				</v-layout>

				<v-layout row wrap pt-3 pr-3 pb-2 pl-3 white-background v-if="roundedAmount">
				  <v-flex center-align xs4 sm4 md4 pr-1>
				    	<v-btn full-width outline light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" flat @click="fn_openAddOns(3, true)"><v-icon font18 style="margin-right:5px">add</v-icon>Charges</v-btn>
				  </v-flex>
				  <v-flex center-align xs4 sm4 md4 pr-1 pl-1>
				    	<v-btn full-width outline light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" flat @click="fn_openAddOns(1, true)"><v-icon font18 style="margin-right:5px">add</v-icon> Discount</v-btn>
				  </v-flex>
				  <v-flex center-align xs4 sm4 md4 pl-1>
				    	<!-- <v-btn full-width outline light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" flat @click="fn_openAddOns(2, true)" v-if="(($root.CurrentBusiness.GSTRegistrationStatus!=1 && !Form.inventory) || ($root.CurrentBusiness.GSTRegistrationStatus==1 && Form.inventory))"><v-icon font18 style="margin-right:5px">add</v-icon> Tax</v-btn> -->
				    	<v-btn full-width outline light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" flat @click="fn_openAddOns(2, true)" v-if="(!this.Form.length && (($root.CurrentBusiness.GSTRegistrationStatus!=1 && !Form.isItcEligible) || ($root.CurrentBusiness.GSTRegistrationStatus==1 && Form.isItcEligible)))"><v-icon font18 style="margin-right:5px">add</v-icon> Tax</v-btn>
				    	<v-btn full-width outline light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" flat @click="fn_openTdsForm" v-else><v-icon font18 style="margin-right:5px">add</v-icon> TDS</v-btn>
				  </v-flex>

				  <!-- <v-flex center-align xs4 sm4 md4></v-flex>
				  <v-flex center-align xs4 sm4 md4></v-flex>
				  <v-flex center-align xs4 sm4 md4 pl-1 mt-2>
				    	<v-btn full-width outline light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" flat @click="fn_openTdsForm"><v-icon font18 style="margin-right:5px">add</v-icon> TDS</v-btn>
				  </v-flex> -->
				</v-layout>

				<!-- <v-layout row wrap pb-3 white-background v-if="roundedAmount && (($root.CurrentBusiness.GSTRegistrationStatus==1 && Form.inventory) || ($root.CurrentBusiness.GSTRegistrationStatus!=1 && !Form.inventory))"> -->
				<v-layout row wrap pb-3 white-background v-if="roundedAmount && (($root.CurrentBusiness.GSTRegistrationStatus==1 && Form.isItcEligible) || ($root.CurrentBusiness.GSTRegistrationStatus!=1 && !Form.isItcEligible))">
					<v-flex center-align xs4 sm4 md4></v-flex>
					<v-flex center-align xs4 sm4 md4></v-flex>
					<v-flex center-align xs4 sm4 md4 pr-3>
						<v-btn full-width outline light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" flat @click="fn_openTdsForm"><v-icon font18 style="margin-right:5px">add</v-icon> TDS</v-btn>
					</v-flex>
				</v-layout>

				<!-- <div margin-top-ten padding-bottom-ten white-background v-if="Form.transactionAddOns.length" class="small-textbox-container">
					<v-subheader>Discounts/Taxes/Other Charges</v-subheader>
					<v-divider></v-divider>
					<v-layout row wrap margin-top-ten class="layout-wrap" v-for="(item, index) in Form.transactionAddOns" :key="index">
					  <v-flex xs8 sm8 md8 class="small-textbox-label">
					  	<v-btn icon @click="fn_removeAddOns(item, index)"><v-icon>close</v-icon></v-btn>
					    <div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}}</div>
					  </v-flex>
					  <v-flex xs4 sm4 md4 pr-3 class="small-textbox">
					    <v-text-field 
					    	v-model.number="item.value" 
					    	@input="item.percentage = null"  
					    	type="number" label="" 
					    	:prefix="item.nature ? '(-)' : ''"
					    	v-validate="'min_value:0|decimal:2'" 
		               		:data-vv-name="'value'+index" 
		               		:data-vv-as="item.name"
		               		:error-messages="errors.collect('value'+index)">
					    </v-text-field>
					  </v-flex>
					</v-layout>
				</div> -->

				<!-- <div margin-top-ten white-background class="small-textbox-container">
					<v-list nopadding>
						<v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title medium-theme-color>Other Charges</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>
	            				<v-btn flat icon color="primary" @click="fn_openAddOns(3, true)" class="no-left-margin">Add</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>
					<v-divider v-if="Form.transactionAddOns.length"></v-divider>
					<v-layout row wrap margin-top-ten class="layout-wrap" v-for="(item, index) in Form.transactionAddOns" :key="index" v-if="item.addOnsType==3">
					  <v-flex xs8 sm8 md8 class="small-textbox-label">
					  	<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
					    <div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}}</div>
					  </v-flex>
					  <v-flex xs4 sm4 md4 pr-3 class="small-textbox">
					    <v-text-field 
					    	v-model.number="item.value" 
					    	@input="item.percentage = null"  
					    	type="number" label="" 
					    	:prefix="item.nature ? '(-)' : ''"
					    	v-validate="'min_value:0|decimal:2'" 
		               		:data-vv-name="'value'+index" 
		               		:data-vv-as="item.name"
		               		:error-messages="errors.collect('value'+index)">
					    </v-text-field>
					  </v-flex>
					</v-layout>
				</div>

				<div margin-top-ten white-background class="small-textbox-container">
					<v-list nopadding>
						<v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title medium-theme-color>Discounts</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>
	            				<v-btn flat icon color="primary" @click="fn_openAddOns(1, true)" class="no-left-margin">Add</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>
					<v-divider v-if="Form.transactionAddOns.length"></v-divider>
					<v-layout row wrap margin-top-ten class="layout-wrap" v-for="(item, index) in Form.transactionAddOns" :key="index" v-if="item.addOnsType==1">
					  <v-flex xs8 sm8 md8 class="small-textbox-label">
					  	<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
					    <div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}}</div>
					  </v-flex>
					  <v-flex xs4 sm4 md4 pr-3 class="small-textbox">
					    <v-text-field 
					    	v-model.number="item.value" 
					    	@input="item.percentage = null"  
					    	type="number" label="" 
					    	:prefix="item.nature ? '(-)' : ''"
					    	v-validate="'min_value:0|decimal:2'" 
		               		:data-vv-name="'value'+index" 
		               		:data-vv-as="item.name"
		               		:error-messages="errors.collect('value'+index)">
					    </v-text-field>
					  </v-flex>
					</v-layout>
				</div>

				<div margin-top-ten white-background class="small-textbox-container">
					<v-list nopadding>
						<v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title medium-theme-color>Taxes{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>
	            				<v-btn flat icon color="primary" class="no-left-margin" @click="fn_openAddOns(2, true)">Add</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>
					<v-divider v-if="Form.transactionAddOns.length"></v-divider>
					<v-layout row wrap margin-top-ten class="layout-wrap" v-for="(item, index) in Form.transactionAddOns" :key="index" v-if="item.addOnsType==2">
					  <v-flex xs8 sm8 md8 class="small-textbox-label">
					  	<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
					    <div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}}</div>
					  </v-flex>
					  <v-flex xs4 sm4 md4 pr-3 class="small-textbox">
					    <v-text-field 
					    	v-model.number="item.value" 
					    	@input="item.percentage = null"  
					    	type="number" label="" 
					    	:prefix="item.nature ? '(-)' : ''"
					    	v-validate="'min_value:0|decimal:2'" 
		               		:data-vv-name="'value'+index" 
		               		:data-vv-as="item.name"
		               		:error-messages="errors.collect('value'+index)">
					    </v-text-field>
					  </v-flex>
					</v-layout>
				</div>

				<v-list full-width nopadding margin-top-ten>

					<v-list-tile>
				  		<v-list-tile-action v-if="Form.tdsDetails.amount">
			            	<v-btn icon @click="fn_removeTds"><v-icon>close</v-icon></v-btn>
			            </v-list-tile-action>
			          	<v-list-tile-content @click="fn_openTdsForm">
			              	<v-list-tile-title medium-theme-color>TDS</v-list-tile-title>
			            </v-list-tile-content>
			            <v-list-tile-action>
            				<v-icon>keyboard_arrow_right</v-icon>
			            </v-list-tile-action>
				    </v-list-tile>

				    <v-divider></v-divider>

				  	<v-list-tile v-if="Form.tdsDetails.amount">
					  <v-list-tile-content>
					    <v-list-tile-title>{{Form.tdsDetails.tdsAccountName}}</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action>(-){{$root.numberToLocale(Form.tdsDetails.amount)}}</v-list-tile-action>
					</v-list-tile>
				</v-list> -->

				<div full-width>
					<div white-background class="small-textbox-container" v-if="otherChargeItems && otherChargeItems.length">

						<v-layout row wrap margin-top-ten class="layout-wrap" v-for="(item, index) in otherChargeItems" :key="index">
						<v-flex xs8 sm8 md8 class="small-textbox-label">
							<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
							<div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}}</div>
						</v-flex>
						<v-flex xs4 sm4 md4 pr-3 class="small-textbox">
							<v-text-field 
								v-model.number="item.value" 
								@input="item.percentage = null"  
								type="number" label="" 
								:prefix="item.nature ? '-' : ''"
								v-validate="'min_value:0|decimal:2'" 
								:data-vv-name="'value'+index" 
								:data-vv-as="item.name"
								:error-messages="errors.collect('value'+index)">
							</v-text-field>
						</v-flex>
						</v-layout>
					</div>

					<div white-background class="small-textbox-container" v-if="discountItems && discountItems.length">
						<v-layout row wrap class="layout-wrap" v-for="(item, index) in discountItems" :key="index">
						<v-flex xs8 sm8 md8 class="small-textbox-label">
							<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
							<div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}}</div>
						</v-flex>
						<v-flex xs4 sm4 md4 pr-3 class="small-textbox">
							<v-text-field 
								v-model.number="item.value" 
								@input="item.percentage = null"  
								type="number" label="" 
								:prefix="item.nature ? '-' : ''"
								v-validate="'min_value:0|decimal:2'" 
								:data-vv-name="'value'+index" 
								:data-vv-as="item.name"
								:error-messages="errors.collect('value'+index)">
							</v-text-field>
						</v-flex>
						</v-layout>
					</div>

					<div white-background class="small-textbox-container" v-if="taxItems && taxItems.length">
						<v-layout row wrap class="layout-wrap" v-for="(item, index) in taxItems" :key="index">
						<v-flex xs8 sm8 md8 class="small-textbox-label">
							<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
							<div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}} {{Form.isRcmApplicable ? ' (RCM)' : ''}}</div>
						</v-flex>
						<v-flex xs4 sm4 md4 pr-3 class="small-textbox">
							<v-text-field 
								v-model.number="item.value" 
								@input="item.percentage = null"  
								type="number" label="" 
								:prefix="item.nature ? '-' : ''"
								v-validate="'min_value:0|decimal:2'" 
								:data-vv-name="'value'+index" 
								:data-vv-as="item.name"
								:error-messages="errors.collect('value'+index)">
							</v-text-field>
						</v-flex>
						</v-layout>
					</div>

					<div white-background class="small-textbox-container" v-if="Form.tdsDetails.amount">
						<v-layout row wrap class="layout-wrap">
						<v-flex xs8 sm8 md8 class="small-textbox-label">
							<v-btn icon @click="fn_removeTds"><v-icon>close</v-icon></v-btn>
							<div @click="fn_openTdsForm">{{Form.tdsDetails.tdsAccountName}}</div>
						</v-flex>
						<v-flex xs4 sm4 md4 pr-3 class="small-textbox">
							<v-text-field 
								@click="fn_openTdsForm"
								readonly
								:value="Form.tdsDetails.amount"
								type="number" 
								label="" 
								prefix="-">
							</v-text-field>
						</v-flex>
						</v-layout>
					</div>
				</div>

				<v-list nopadding v-if="roundedAmount">
					<v-list-tile>
						<v-list-tile-action style="margin-right:-16px">
							<v-checkbox v-model="Form.isRounded" style="width: 32px;float:left"></v-checkbox>
						</v-list-tile-action>
					  	<v-list-tile-content>
					    	<v-list-tile-title>Round Off</v-list-tile-title>
					  	</v-list-tile-content>
					  	<!-- <v-list-tile-action :class="[Form.isRounded && netAmount ? 'text-underline' : 'light-opacity-color']" @click="fn_openDialogRoundOff" v-if="Form.isRounded">&#8377; {{roundOff}}</v-list-tile-action> -->
					  	<v-list-tile-action style="width:33.33%" @click="fn_openDialogRoundOff" v-if="Form.isRounded">
					  		<v-text-field 
					  			align-input-text-right
								:value="roundOff"
								readonly
								type="number" 
								label="" 
								prefix="₹">
							</v-text-field>
					  	</v-list-tile-action>
					</v-list-tile>
					<v-divider></v-divider>
					<v-list-tile font-medium>
					  <v-list-tile-content>
					    <v-list-tile-title>Total Amount</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action style="align-items: center;}">&#8377; {{$root.numberToLocale(roundedAmount)}}</v-list-tile-action>
					</v-list-tile>
				</v-list>

				<!-- <v-list nopadding margin-top-ten>
					<v-list-tile>
						<v-list-tile-action style="margin-right:-16px">
							<v-checkbox v-model="Form.isRounded" style="width: 32px;float:left"></v-checkbox>
						</v-list-tile-action>
					  <v-list-tile-content>
					    <v-list-tile-title>Round Off</v-list-tile-title>
					  </v-list-tile-content>
					  
					  <v-list-tile-action :class="[Form.isRounded && netAmount ? 'text-underline' : 'light-opacity-color']" @click="fn_openDialogRoundOff">&#8377; {{roundOff}}</v-list-tile-action>
					</v-list-tile>
				</v-list>

				<v-list nopadding margin-top-ten>
					<v-list-tile>
					  <v-list-tile-content>
					    <v-list-tile-title>Total Amount</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action style="align-items: flex-start;padding-top: 8px;}">&#8377; {{$root.numberToLocale(roundedAmount)}}</v-list-tile-action>
					</v-list-tile>
				</v-list> -->

				<!-- <v-list two-line nopadding margin-top-ten>
					<v-list-tile>
					  <v-list-tile-content>
					    <v-list-tile-title>Total Amount</v-list-tile-title>
					    <v-list-tile-sub-title style="line-height: 34px;">
					    	<v-checkbox v-model="Form.isRounded" style="width: 32px;float:left"></v-checkbox>
					    	Round Off
					    </v-list-tile-sub-title>
					  </v-list-tile-content>
					  <v-list-tile-action style="align-items: flex-start;padding-top: 8px;}">&#8377; {{$root.numberToLocale(roundedAmount)}}</v-list-tile-action>
					</v-list-tile>
				</v-list> -->

				<!-- <v-layout row wrap margin-top-ten white-background v-if="Form.customFields.length">

					<v-expansion-panel nomargin v-model="expandCustomFields">

					    <v-expansion-panel-content v-for="(item, index) in Form.customFields" :key="index" :id="'section_'+item.section.sectionId">

					    	<v-divider></v-divider>

					    	<v-subheader nopadding>

					    		<v-layout row wrap>
					    			<v-flex xs6 sm6 md6 center-align right-border>
					    		  		<v-btn flat small color="primary" nomargin @click="fn_bindDynamicFields(item.section.sectionId)">edit</v-btn>
					    			</v-flex>
					    			<v-flex xs6 sm6 md6 center-align>
					    		  		<v-btn flat small color="primary" nomargin @click="fn_removeFields(index, item.section.sectionId)">remove</v-btn>
					    			</v-flex>
					    		</v-layout>

							</v-subheader>

					      <div slot="header" font16>{{item.section.sectionName}}</div>

					      <v-divider></v-divider>

					      <v-card v-for="(fieldItem, itemIndex) in item.items" :key="itemIndex" v-if="fieldItem.value">
					        <v-card-text>
					        	<div><b>{{fieldItem.displayName}}</b></div>
					        	<div v-if="fieldItem.fieldType=='yes/no'">{{fieldItem.value ? 'Yes' : 'No'}}</div>

					        	<div v-else-if="fieldItem.fieldType=='dateTime'">
					        		<span v-if="fieldItem.value">{{fieldItem.value | moment("DD-MMM-YYYY")}}</span>
					        		<span v-else>-</span>
					        	</div>

					  			<div v-else v-html="fieldItem.value ? fieldItem.value : '-'" white-space-pre-line></div>
					        </v-card-text>
					      </v-card>

					    </v-expansion-panel-content>

					  </v-expansion-panel>

				</v-layout>	

				<v-list nopadding :class="{'margin-top-ten': !Form.customFields.length}">

					<div v-for="(item, index) in Form.dynamicMenuItems" :key="index" v-if="!item.hideOption">
						<v-list-tile>
						  	<v-list-tile-content>
						    	<v-list-tile-title>{{item.Text}}</v-list-tile-title>
						  	</v-list-tile-content>
						  	<v-list-tile-action>
						  		<v-btn color="primary" flat icon @click="fn_bindDynamicFields(item.sectionId)" class="no-left-margin">
						  			Add
						  		</v-btn>
						  	</v-list-tile-action>
						</v-list-tile>

						<v-divider v-if="Form.dynamicMenuItems.length-1 != index"></v-divider>
					</div>

					<v-divider v-if="roundedAmount>=50000 && !Form.hideEwayOption"></v-divider>
					<v-list-tile v-if="roundedAmount>=50000 && !Form.hideEwayOption">
					  	<v-list-tile-content>
					    	<v-list-tile-title data-no-translate>E-Way Bill Details</v-list-tile-title>
					  	</v-list-tile-content>
					  	<v-list-tile-action>
					  		<v-btn color="primary" flat icon @click="fn_bindDynamicFields(ewayBillDetailSection.sectionId)" class="no-left-margin">
					  			Add
					  		</v-btn>
					  	</v-list-tile-action>
					</v-list-tile>
				</v-list> -->

				<v-layout wrap margin-top-ten white-background :class="{'margin-bottom-five':Form.transactionData.notes}" v-if="roundedAmount">
					<v-list full-width nopadding>
					  	<v-list-tile>

					  		<v-list-tile-action v-if="Form.transactionData.notes">
				            	<v-btn icon @click="Form.transactionData.notes = ''">
						  			<v-icon>close</v-icon>
						  		</v-btn>
				            </v-list-tile-action>

				          	<v-list-tile-content full-width @click="fn_addNote">
				              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
							  <v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
				            </v-list-tile-content>
					    </v-list-tile>
					</v-list>

					<v-card full-width flat class="note-card" v-if="Form.transactionData.notes">
						<v-divider></v-divider>
					  	<v-card-text font16 v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
					</v-card>
				</v-layout>

				<v-layout full-width row wrap id="custom_field_panel" v-if="roundedAmount">
					
					<div full-width v-for="(dItem, dIndex) in Form.dynamicMenuItems" :key="dIndex">
						<v-list nopadding white-background>
							<v-list-tile @click="fn_bindDynamicFields(dItem.sectionId)" v-if="!dItem.hideOption">
							  	<v-list-tile-content>
							    	<v-list-tile-title>{{dItem.Text}}</v-list-tile-title>
							  	</v-list-tile-content>
							  	<v-list-tile-action>
							  		<v-icon>keyboard_arrow_right</v-icon>
							  	</v-list-tile-action>
							</v-list-tile>
						</v-list>

						<div class="pb-3" white-background full-width v-for="(item, index) in Form.customFields" :key="index" v-if="dItem.sectionId == item.section.sectionId" :class="{'margin-top-bottom-five':dItem.sectionId == item.section.sectionId}" data-no-translate>
							<v-list nopadding :id="'section_'+item.section.sectionId">
								<v-list-tile>
									<v-list-tile-action>
								  		<v-btn icon @click="fn_removeFields(index, item.section.sectionId)">
								  			<v-icon>close</v-icon>
								  		</v-btn>
								  	</v-list-tile-action>

								  	<v-list-tile-content full-width @click="fn_bindDynamicFields(item.section.sectionId)">
								    	<v-list-tile-title>{{item.section.sectionName}}</v-list-tile-title>
										<v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
								  	</v-list-tile-content>
								</v-list-tile>
							</v-list>

							<v-divider></v-divider>

						      <v-card flat v-for="(fieldItem, itemIndex) in item.items" :key="itemIndex" v-if="fieldItem.value">
						        <v-card-text class="pb-0">
						        	<div font12 light-theme-color>{{fieldItem.displayName}}</div>
						        	<div font16 v-if="fieldItem.fieldType=='yes/no'">{{fieldItem.value ? 'Yes' : 'No'}}</div>

						        	<div font16 v-else-if="fieldItem.fieldType=='dateTime'">
						        		<span v-if="fieldItem.value">{{fieldItem.value | moment("DD-MMM-YYYY")}}</span>
						        		<span v-else>-</span>
						        	</div>

						  			<div font16 v-else v-html="fieldItem.value ? fieldItem.value : '-'" white-space-pre-line></div>
						        </v-card-text>
						      </v-card>
						</div>
					</div>

					<v-list full-width nopadding v-if="(roundedAmount>=50000 || $root.TransactionSettings.eWayBillConfigValue === 1) && !Form.hideEwayOption && $root.CurrentBusiness.GSTRegistrationStatus == 1">
						<v-list-tile @click="fn_bindDynamicFields(ewayBillDetailSection.sectionId)">
						  	<v-list-tile-content>
						    	<v-list-tile-title>E-Way Bill Details</v-list-tile-title>
						  	</v-list-tile-content>
						  	<v-list-tile-action>
						  		<v-icon>keyboard_arrow_right</v-icon>
						  	</v-list-tile-action>
						</v-list-tile>
					</v-list>

					<div class="pb-3" white-background full-width margin-top-bottom-five v-for="(item, index) in Form.customFields" :key="index" margin-top-ten v-if="ewayBillDetailSection.sectionId == item.section.sectionId" data-no-translate>
						<v-list nopadding :id="'section_'+item.section.sectionId">
							<v-list-tile>
								<v-list-tile-action>
							  		<v-btn icon @click="fn_removeFields(index, item.section.sectionId)">
							  			<v-icon>close</v-icon>
							  		</v-btn>
							  	</v-list-tile-action>

							  	<v-list-tile-content full-width @click="fn_bindDynamicFields(item.section.sectionId)">
							    	<v-list-tile-title>{{item.section.sectionName}}</v-list-tile-title>
									<v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
							  	</v-list-tile-content>
							</v-list-tile>
						</v-list>

						<v-divider></v-divider>

					      <v-card flat v-for="(fieldItem, itemIndex) in item.items" :key="itemIndex" v-if="fieldItem.value">
					        <v-card-text class="pb-0">
					        	<div font12 light-theme-color>{{fieldItem.displayName}}</div>
					        	<div font16 v-if="fieldItem.fieldType=='yes/no'">{{fieldItem.value ? 'Yes' : 'No'}}</div>

					        	<div font16 v-else-if="fieldItem.fieldType=='dateTime'">
					        		<span v-if="fieldItem.value">{{fieldItem.value | moment("DD-MMM-YYYY")}}</span>
					        		<span v-else>-</span>
					        	</div>

					  			<div font16 v-else v-html="fieldItem.value ? fieldItem.value : '-'" white-space-pre-line></div>
					        </v-card-text>
					      </v-card>
					</div>

				</v-layout>

				<v-layout wrap margin-top-ten white-background v-if="roundedAmount">
					<v-list full-width nopadding>
						<v-list-tile>
				          	<v-list-tile-content>
								<v-list-tile-title medium-theme-color>Attachments {{ Form.attachments.length ? '('+Form.attachments.length+')' : '' }}</v-list-tile-title>
								<!-- <v-list-tile-title medium-theme-color>Attachments</v-list-tile-title> -->
				            </v-list-tile-content>

				            <v-list-tile-action>
	            				<v-btn flat icon color="primary" @click="fn_getBottomMenuAttachment" :disabled="$root.CurrentBusiness.temporaryBusiness ? true : false" class="no-left-margin">
									<v-icon>attachment</v-icon>
								</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
						<v-divider v-if="Form.attachments.length"></v-divider>
						<template v-for="(item, index) in Form.attachments">
							<v-list-tile :key="index" :id="'doc_'+item.documentId" v-if="item.uploadStatus!=2">
					          	<v-list-tile-content>
					              <v-list-tile-title medium-theme-color>{{item.fileName}}</v-list-tile-title>
					            </v-list-tile-content>

					            <v-list-tile-action>
		            				<v-btn flat icon color="primary" :disabled="$root.CurrentBusiness.temporaryBusiness ? true : false" @click="fn_removeAttachment(item)"><v-icon>close</v-icon></v-btn>
					            </v-list-tile-action>
						    </v-list-tile>
						    <v-divider v-if="Form.attachments.length-1 != index"></v-divider>
						</template>
					</v-list>
				</v-layout>	

				<!-- <v-layout row wrap margin-top-ten white-background v-if="Form.transactionData.paymentMode==1 && roundedAmount>0">

					<v-subheader full-width border-bottom-thin nomargin norightpadding>Payment Mode
						<v-spacer></v-spacer>
						<v-menu min-width="120">

					      <v-btn slot="activator" icon>
					      	<v-icon>more_vert</v-icon>
					      </v-btn>
					      <v-list nopadding>
					        <v-list-tile @click="fn_openDialog_PaymentOptions">
					          <v-list-tile-title>Change</v-list-tile-title>
					        </v-list-tile>
					      </v-list>

					    </v-menu>
					</v-subheader>


					<v-list nopadding full-width>

					  	<div v-if="!Form.splitPayment">
							<v-list-tile>
								<v-list-tile-content>
									<v-list-tile-title>{{fn_paymentAccountName(Form.paymentLedgerId)}}</v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>&#8377; {{$root.numberToLocale(roundedAmount)}}</v-list-tile-action>
							</v-list-tile>	
						</div>

						<div v-for="(item, index) in Form.paymentOptions" :key="index" v-else>
							<v-list-tile>
						  		<v-list-tile-content>
						  		 	<v-list-tile-title>{{item.accountLedgerId == creditAccountLedgerId ? 'On Credit' : item.accountLedgerName}}</v-list-tile-title>
						  		</v-list-tile-content>
						  		<v-list-tile-action>&#8377; {{$root.numberToLocale(item.amount)}}</v-list-tile-action>
						  	</v-list-tile>	
						</div>
						
					  	
					</v-list>

				</v-layout>	 -->	 

				<v-list nopadding margin-top-ten v-if="Form.splitPayment && Form.paymentOptions && Form.paymentOptions.length">
					<v-list-tile>
			          	<v-list-tile-content>
			              <v-list-tile-title medium-theme-color>Payment Mode</v-list-tile-title>
			            </v-list-tile-content>
				    </v-list-tile>
				    <v-divider></v-divider>
					<v-list-tile v-for="(item, index) in Form.paymentOptions" :key="index">
			          	<v-list-tile-content>
			              <v-list-tile-title medium-theme-color>
			              	<span v-if="item.accountLedgerId == creditAccountLedgerId">On Credit</span>
			              	<span v-else>{{item.accountLedgerName}}</span>
			              </v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>&#8377; {{item.amount}}</v-list-tile-action>
				    </v-list-tile>
				</v-list>   

				<v-layout wrap margin-top-ten padding-top-bottom-ten white-background v-if="roundedAmount && $root.appVersion >= 117">
					<v-flex xs12 sm12 md12 form-item @click="fn_openDialogPaymentTerm">
						<v-text-field 
			               	readonly
			               	:value="!Form.selectedPaymentTerm ? 'Custom' : Form.selectedPaymentTerm != -1 ? Form.selectedPaymentTerm + ' Days' : 'No Due Date'"
			               	label="Term of Payment"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
		               		required>
		               	</v-text-field>	
					</v-flex>

					<v-flex xs12 sm12 md12 form-item v-if="!Form.selectedPaymentTerm">
						<v-text-field 
							v-model="Form.paymentTerm"
							type="number"
			               	label="Enter Term of Payment"
			               	placeholder=" " 
			               	v-validate="'required'" 
		               		data-vv-name="paymentTerm" 
		               		data-vv-as="payment term" 
		               		:error-messages="errors.collect('paymentTerm')"
		               		required>
		               	</v-text-field>	
					</v-flex>
				</v-layout>

			</div>

			<div white-background full-width nopadding style="position:fixed;bottom:0;">

				<!-- <v-layout row wrap v-if="Form.isCashTransaction">
					<v-flex xs12 sm12 md12>
						<v-btn color="primary height48" nomargin block no-round-borders noshadow @click="fn_checkValidations">Save</v-btn>
					</v-flex>
				</v-layout> -->

				<!-- <v-layout row wrap v-else> -->
				<v-layout row wrap>
					<v-flex xs6 sm6 md6 style="padding:6px 6px 6px 16px" @click="fn_openDialog_PaymentOptions" v-ripple>
						<div font-medium style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">&#8377; {{$root.numberToLocale(roundedAmount)}}</div>
						<div style="font-size:11px">
							<span light-opacity-color style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">Payment:&nbsp;</span> <span style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">{{!Form.splitPayment ? fn_paymentAccountName(Form.paymentLedgerId) : 'Split Payment'}}</span> <v-icon font16 style="line-height:12px">arrow_drop_down</v-icon>
							<!-- {{!Form.splitPayment ? fn_paymentAccountName(Form.paymentLedgerId) : 'Split Payment'}} -->
							<!-- <v-icon font16 style="line-height:12px">arrow_drop_down</v-icon> -->
						</div>
					</v-flex>
					<v-flex xs6 sm6 md6>
						<v-btn color="primary full-height" nomargin block no-round-borders noshadow @click="fn_checkValidations">Save</v-btn>
					</v-flex>
				</v-layout>

				<!-- <v-layout row wrap>
					<v-flex xs6 sm6 md6 style="padding:6px 6px 6px 16px" @click="fn_openDialog_PaymentOptions" v-ripple v-if="!Form.isCashTransaction">
						<div font-medium style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">&#8377; {{$root.numberToLocale(roundedAmount)}}</div>
						<div style="font-size:11px">
							{{!Form.splitPayment ? fn_paymentAccountName(Form.paymentLedgerId) : 'Split Payment'}}
							<v-icon font16 style="line-height:12px">arrow_drop_down</v-icon>
						</div>
					</v-flex>
					<v-flex xs6 sm6 md6 :class="{'xs12 sm12 md12': Form.isCashTransaction}">
						<v-btn color="primary" :class="[Form.isCashTransaction ? 'height48' : 'full-height']" nomargin block no-round-borders noshadow @click="fn_checkValidations">Save</v-btn>
					</v-flex>
				</v-layout> -->
			</div>

		</v-form>

		<!-- <v-btn color="success" @click="showBottomToolbar = !showBottomToolbar">text</v-btn> -->

		<!-- <transition name="tools">
			<v-layout grid wrap text-xs-center class="bottomtools" transition="slide-y-transition" v-if="showBottomToolbar">
				<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple>
					<div right-border>
						<div><v-icon>send</v-icon></div>
				    	<div class="font-weight-bold">Send</div>
					</div>	
				</v-flex>

				<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple>
				    <div right-border>
				    	<div><v-icon>print</v-icon></div>
				    	<div class="font-weight-bold">Print</div>
				    </div>
				</v-flex>

				<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple>
				    <div right-border>
				    	<div><v-icon>import_export</v-icon></div>
				    	<div class="font-weight-bold">Export</div>
				    </div>
				</v-flex>

				<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple>
				    <div>
				    	<div><v-icon>more_horiz</v-icon></div>
				    	<div class="font-weight-bold">More</div>
				    </div>
				</v-flex>
			</v-layout>
		</transition> -->

	   <!--  <v-dialog v-model="loading" no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog> -->

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	    <v-snackbar v-model="transactionNumberSnackbar" multi-line :timeout="0">
	    	Generate new transaction number?
	    	<v-btn flat icon @click="fn_bindTransactionNumber" color="primary">okay</v-btn>
	    	<v-btn flat icon @click="transactionNumberSnackbar=false">close</v-btn>
	    </v-snackbar>

		<!-- <v-snackbar v-model="snackbarTaxCategory" multi-line :timeout="0">
	    	Consider updating tax category of item(s)
	    	<v-btn flat icon @click="snackbarTaxCategory=false" color="primary">okay</v-btn>
	    </v-snackbar> -->

		<v-bottom-sheet v-model="snackbarTaxCategory" v-if="snackbarTaxCategory">
			<v-card flat>
				<v-card-title noshadow class="title">Update Taxes</v-card-title>
				<v-card-text>
					Consider updating tax category of item(s) as per applicable tax forms.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="snackbarTaxCategory=false">cancel</v-btn>
					<v-btn color="primary" flat @click="fn_getProductData(null)">Okay</v-btn>
				</v-card-actions>
			</v-card>
		</v-bottom-sheet>

	    <dialog-transaction-type-list ref="ref_dialogTransactionTypeList" :transactionTypeId="settings.transactionTypeId" :setTransactionType="fn_setTransactionType" :openConfirmationDialog="fn_openConfirmationDialog" :selectedTypeFormId="Form.transactionTypeFormId" :transactionTypeList="Form.transactionTypeList"></dialog-transaction-type-list>

	    <!-- <dialog-datepicker ref="ref_dialogDatePicker" :minDate="minTransactionDate" :maxDate="maxTransactionDate" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker> -->
		<dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker>

	    <dialog-note ref="ref_dialogNote"></dialog-note>
	    <dialog-number-series ref="ref_dialogNumberSeries" :checkTransactionNumber="fn_checkTransactionNumber"></dialog-number-series>

	    <dialog-tds ref="ref_dialogTds" :openAccountLedgers="fn_openAccountLedgers" :saveTdsDetails="fn_saveTdsDetails" :deleteTds="fn_removeTds"></dialog-tds>

	    <dialog-product ref="ref_dialogProduct" :openProducts="fn_openProducts" :openTaxCategories="fn_openTaxCategories" :saveItem="fn_saveItem"></dialog-product>

	    <!-- <dialog-tax-categories ref="ref_dialogTaxCategories" :setProductTaxValue="fn_setProductTaxValue" :currentTaxValue="Form.productDataModel.taxValue"></dialog-tax-categories> -->
	    <dialog-tax-categories ref="ref_dialogTaxCategories" :taxCategories="taxCategories" :updateTaxCategory="fn_updateTaxCategory" 
    	:selectedTaxCategoryId="Form.productDataModel.taxCategoryId"></dialog-tax-categories>

	    <dialog-addons ref="ref_dialogAddOns" :openAddOnsList="fn_openAddOnsList" :addOnsProp="Form.addOnsProp" :saveAddOns="fn_saveAddOns"></dialog-addons>

	    <!-- <dialog-confirmation ref="ref_dialogChangeTransactionType" :confirmationMessage="confirmationMessage" type="transactiontypeform" :actionMethod="fn_confirm"></dialog-confirmation> -->

	    <dialog-dynamic-fields ref="ref_dialogDynamicFields" :saveFields="fn_saveFields" :openAccountLedgers="fn_openAccountLedgers" :openListItems="fn_openListItems" :openDatePicker="fn_openDatePicker"></dialog-dynamic-fields>

	    <dialog-payment-options ref="ref_dialogPaymentOptions" :savePaymentOptions="savePaymentOptions"></dialog-payment-options>

		<dialog-payment-term ref="ref_dialogPaymentTerm" :updatePaymentTerm="fn_updatePaymentTerm" :selectedPaymentTerm="Form.selectedPaymentTerm"></dialog-payment-term>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations"></dialog-discard>

	    <!-- <dialog-confirmation ref="ref_dialogCancelTransaction" header="Cancel Transaction?" :confirmationMessage="confirmationMessage" :actionMethod="fn_callCancelTransaction"></dialog-confirmation> -->

        <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="confirmationAction" okBtnText="Yes" cancelBtnText="No" :displayView="true" :params="confirmationActionParam"></dialog-confirmation>

	    <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items>

	    <dialog-roundoff ref="ref_dialogRoundOff"></dialog-roundoff>

		<!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->

		<dialog-parties ref="ref_dialogLedger" :newParty="fn_menuItemClick" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-parties>
		<dialog-products ref="ref_dialogProductList" :setNewProduct="this.fn_setNewProduct" :newProduct="fn_menuItemClick" menuItemClickParam="newproduct" :closeDialog="fn_closeDialog"></dialog-products>
		<dialog-selection-list ref="ref_dialogSelectionList" :fnAction="fn_menuItemClick" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-selection-list>

	    <!-- <dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_gotoSetupDrive"></dialog-drive-alert> -->
		<dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_setupDrive" :skipAlert="fn_closeDialog" :transactionCount="transactionCount"></dialog-drive-alert>

		<dialog-old-tax-update 
	    	ref="ref_dialogOldTaxUpdate">
	    </dialog-old-tax-update>
	</div>
</template>

<script>
const dialogjs =  require('../../../masters/forms/dialog').dialogjs;

const menuItem = require('../../../../config.js').configs.menuItem;
const transactionForms = require('../../../../config.js').configs.transactionForms;
const transactionTypes = require('../../../../config.js').configs.transactionTypes;

const ledgerGroupTypeId = require('../../../../config.js').configs.ledgerGroupTypeId;
const accountGroupIds = require('../../../../config.js').configs.accountGroupIds;
const productGroupTypeId = require('../../../../config.js').configs.productGroupTypeId;
const fixedGstAddOns = require('../../../../config.js').configs.fixedGstAddOns;
const fixedCessAddOns = require('../../../../config.js').configs.fixedCessAddOns;
const fixedAccountIds = require('../../../../config.js').configs.fixedAccountIds;
const paymentAccountsAndLedger = require('../../../../config.js').configs.paymentAccountsAndLedger;

const transactionData = require('../../datamodel').data.transactionData;

import dialogTransactionTypeList from '../dialogs/dialog_transaction_type_list'	//coming from outer dialogs folder
import dialogDatePicker from './dialogs/dialog_datepicker';
import dialogNote from '../dialogs/dialog_note'
import dialogNumberSeries from '../dialogs/dialog_number_series_manual'
import dialogTds from '../dialogs/dialog_tds'

import dialogProduct from './dialogs/dialog_product'

import dialogPaymentOptions from '../dialogs/dialog_payment_options'

import dialogTaxCategories from '../../../dialogs/dialog_tax_categories'

import dialogAddOns from '../../../dialogs/dialog_addons'
import dialogConfirmation from '../../../dialogs/dialog_confirmation'

import dialogDynamicFields from '../../../dialogs/dialog_dynamic_fields'

import dialogPaymentTerm from '../dialogs/dialog_payment_terms'

import dialogDiscard from '../../../dialogs/dialog_discard'
import {draftMixin} from '../../../draft_mixin'
import {transactionMixin} from '../../transaction_mixin'
import dialogDraftItems from '../../../dialogs/dialog_draft_items'
import dialogRoundOff from '../dialogs/dialog_roundoff'

import dialogParties from '../../../dialogs/dialog_parties'
import dialogProducts from '../../../dialogs/dialog_products'
import dialogSelectionList from '../../../dialogs/dialog_selection_list'

import dialogDriveAlert from '../../../dialogs/dialog_drive_alert'
import dialogOldTaxUpdate from '../dialogs/dialog_old_tax_update'

	export default{
		props:['settings'],
		mixins: [draftMixin, transactionMixin],
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                     // this.fn_saveToLocalStorage(this);
                     if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.partyName);
                     }
                     this.unwatch = false;
                 },
                 deep: true
            }
		},
		data(){
			return{
				Form:{
					"transactionData":JSON.parse(JSON.stringify(transactionData)),
					"partyId":null, "partyName":null,
					"taxMode":0,
					"transactionTypeFormId":null, "transactionTypeFormName":null,

					"items":[],

					"expenseData":{"accountLedgerId":null, "accountLedgerName":null, "amount":null, "items":[]},

					"productDataModel": {"groupId":null, "productId":null, "groupTypeId":null, "productName":null, "mrp":null, "rate":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "cessAmount":0, "taxCategoryId": null, "taxCategoryName": null, 
						"defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null, "description":null},

					"addOnsDataModel": {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":null, "type":null},

					"tdsDataModel":{
						"transactionTdsId":null, "transactionId":null, "tdsAccountId":null, "tdsAccountName":null, "appliedOnAmount":null, "percentage":null, "amount":null
					},

					"transactionAddOns":[],

					"tdsDetails":{"amount":0},

					"addOnsProp":{},

					"itemsSummary":{"grossAmount":0, "grossAmountAsPerMRP":0, "addOnsItems":[], "taxValue":0, "itemsQuanity":[]},

					"transactionTypeData":null,
					"dynamicFields":{"section":null, "items":[], "accountGroupId":null, "accountGroupName":null, "ref":null},

					"dynamicFieldsAdditionalData":{},

					"customFields":[],

					"dynamicMenuItems":[],

					"partyDetails":null,

					"gstType":null,

					"defaultTaxAddOns":[],

					"gstAddOns":[],
					"cessAddOns":null,

					"savedItemData":null,
					"isNew":true,

					"transactionTypeList":[],
					// "inventory":0,
					"draftItems":[],
					"hideEwayOption": false,
					"placeOfSupplyId":null,
					"placeOfSupplyName":null,
					"placeOfSupplyCountryId":null,
					"placeOfSupplyCountryName":null,
					// "partyGstType":null,
					"isRounded":this.$root.TransactionSettings.isAutoRoundOff ? true : false,
					"roundOffValue":null,
					"isRcmApplicable":false,
					"attachments":[],

					"onCredit":true,
					"paymentLedgerId":null,
					"paymentGroups":null,
					"splitPayment":false,
					"paymentOptions":[],
					"balanceAsOn":0,
					"description":null,
					// "newSelection":false,
					"expenseCategoryId":null,
					"expenseCategoryName":null,
					"paymentGroupIndex":null,
					"isCashTransaction":false,
					"isItcEligible":false,
					"paymentTerm":30,
					"selectedPaymentTerm":-1,
					// "godownId":null,
					// "godownName":null
					// "invoiceType":0
				},

				toolbarTitle:null,
				loading:true,
				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,

				backButtonPress: false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,
				// loadedFromDraft:false,

				dateType:null,
				selectedDate:null,
				confirmationMessage:null,

				// passStockEntry:false,
				passLedgerEntry:true,
				taxCategories:null,
				ledgerType:'ledger',
				transactionNumberSnackbar:false,
				disableSaveBtn:false,
			}
		},
		components:{
			// 'dialog-currency-list': dialogCurrencyList,
			'dialog-transaction-type-list': dialogTransactionTypeList,
			'dialog-datepicker': dialogDatePicker,
			'dialog-note':dialogNote,
			'dialog-tds':dialogTds,
			'dialog-product':dialogProduct,
			'dialog-tax-categories':dialogTaxCategories,
			'dialog-addons':dialogAddOns,
			'dialog-confirmation':dialogConfirmation,
			'dialog-dynamic-fields':dialogDynamicFields,
			'dialog-discard': dialogDiscard,
			'dialog-number-series': dialogNumberSeries,
			'dialog-draft-items': dialogDraftItems,
			'dialog-roundoff':dialogRoundOff,
			'dialog-payment-options':dialogPaymentOptions,
			'dialog-payment-term': dialogPaymentTerm,
			'dialog-drive-alert':dialogDriveAlert,
			'dialog-parties':dialogParties,
			'dialog-products':dialogProducts,
			'dialog-selection-list':dialogSelectionList,
			'dialog-old-tax-update': dialogOldTaxUpdate
			// 'dialog-particular':dialogParticular,
			// 'dialog-transactions-list':dialogPendingTransactions,
			// 'dialog-return-form':dialogReturnForm
		},
		methods:{

			// fn_checkIfTaxApplicable: function(){
			// 	// tax will not applicable in below cases
			// 	// - unregister business
			// 	// - cash expense
			// 	// - supplier not applicable
			// 	if(this.$root.CurrentBusiness.GSTRegistrationStatus!=3){
			// 		if(!this.Form.isCashTransaction && !this.Form.supplierNA){
			// 			return true;
			// 		}
			// 		else{
			// 			return false;
			// 		}
			// 	}
			// 	else{
			// 		return false;
			// 	}
			// },

			fn_openDialogRoundOff: function(){
				if(!this.Form.isRounded || !this.netAmount){
					return;
				}
				this.Form.roundOffValue = this.roundOff;
				this.fn_openDialogWeb('web', 'RoundOff', 'ref_dialogRoundOff');
			},

			fn_setRoundOffValue: function(value, nature){
				this.Form.roundOffValue = nature ? value: -value;
				this.fn_closeDialog();
			},


			fn_openDialogNumberSeries: function(){
				this.fn_openDialogWeb('web', 'NumberSeries', 'ref_dialogNumberSeries');
				this.transactionNumberSnackbar = false;
			},

			fn_openDialogPaymentTerm: function(){
				this.fn_openDialogWeb('web', 'PaymentTerm', 'ref_dialogPaymentTerm')
			},

			fn_updatePaymentTerm: function(val){
				this.fn_closeDialog();
				!val ? this.Form.paymentTerm = null : '';
				this.Form.selectedPaymentTerm = val;
			},

			fn_byCash: function(val){

				if(val){
					this.Form.splitPayment = false
					this.Form.paymentOptions = [];

					this.Form.isRcmApplicable = false;
					this.Form.isItcEligible = false;

					this.Form.paymentLedgerId = paymentAccountsAndLedger.ledgers.cash;
					this.Form.partyId = null;
					this.Form.partyName = null;
					this.fn_updateState(this.$root.CurrentBusiness.StateID, this.$root.CurrentBusiness.State, false);
				}
				else{
					this.Form.paymentLedgerId = this.creditAccountLedgerId;
					this.Form.partyDetails = null;
				}

				this.Form.taxMode = 0;
				this.fn_calculateTax();
				// force save to draft
				this.fn_saveDraft(this.Form.partyName);
			},

			fn_getPaymentCashAccountId: function(){
				return paymentAccountsAndLedger.ledgers.cash;
			},

			fn_itcEligible: function(val){
				if(!val){
					this.Form.transactionAddOns = this.Form.transactionAddOns.filter(item=>{
						return item.addOnsType != 2;
					});
				}

				this.Form.taxMode ? this.fn_calculateTax() : '';
			},

			// fn_itcEligible: function(val){
			// 	if(!val){
			// 		this.Form.taxMode = 0;
			// 		this.Form.isCashTransaction = true;
			// 		this.fn_byCash(true);
			// 		this.Form.partyId = null;
		 //        	this.Form.partyName = null;
			// 	}
			// 	else{
			// 		this.Form.isCashTransaction = false;
			// 		this.fn_byCash(false);
			// 	}
			// },

			// fn_callCancelTransaction: function(){
			// 	this.fn_closeDialog();
			// 	this.fn_cancelTransaction(this.Form.transactionData.transactionId, this.Form.transactionData.transactionListId, 'form');
			// },

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard');
			},

			fn_partyLabel: function(){
				if(this.Form.placeOfSupplyCountryName){
					return "Supplier (" + this.Form.placeOfSupplyCountryName + ")";
					// if(this.Form.inventory){
					// 	return "Supplier (" + this.Form.placeOfSupplyCountryName + ")";
					// }
					// else{
					// 	return "Supplier (" + this.Form.placeOfSupplyCountryName + ") (Optional)";			
					// }
				}
				else{
					return "Supplier";
					// if(this.Form.inventory){
					// 	return "Supplier";
					// }
					// else{
					// 	return "Supplier (Optional)";		
					// }
				}
			},

			fn_getTransactionTypeList: function (setTFT) {
		        let filterObject = {};
		        filterObject.type = this.settings.transactionTypeId;
		        // filterObject.accountGroupStatus = 1;
		        filterObject.accountGroupsHidden = [2];
		        if(this.$root.CurrentBusiness.GSTRegistrationStatus != 1){
		        	filterObject.inventory = [0];
		        }
		        else{
		        	filterObject.inventory = [0, 1];
		        }

		        let self = this;
		        this.getItems("TransactionTypeList", filterObject, 
		          {
		            onSuccess: function (response) {
		              	console.log(response);

		              	self.unwatch = true;

		              	self.Form.transactionTypeList = JSON.parse(response);

		              	setTFT ? self.fn_setLastSelectedTFT() : '';

		    //           	if(!self.loadedFromDraft && self.Form.isNew){

		    //           		if(self.Form.transactionTypeList.length && !self.Form.transactionTypeFormId){

				  //             	if(localStorage.getItem(self.settings.transactionTypeId)){
				  //             		let transactionTypeFormId = localStorage.getItem(self.settings.transactionTypeId);

				  //             		for(let i=0; i<self.Form.transactionTypeList.length; i++){
				  //             			if(self.Form.transactionTypeList[i].transactionTypeFormId == transactionTypeFormId){
				  //             				self.fn_setTransactionType(self.Form.transactionTypeList[i]);
				  //             				break;
				  //             			}
				  //             		}              		
				  //             	}
				  //             	else{
				  //             		if(self.Form.transactionTypeList.length == 1){
				  //             			self.fn_setTransactionType(self.Form.transactionTypeList[0]);
				  //             		}
				  //             	}

				  //           }
					
						// }     
		              
		            },
		            onError: function (error) {
		              console.log(error);
		            }
		          }
		        )
		    },

		    fn_setLastSelectedTFT: function(){
		    	if(localStorage.getItem(this.settings.transactionTypeId) && this.Form.transactionTypeList.length){
  					let transactionTypeFormId = localStorage.getItem(this.settings.transactionTypeId);

  					let itemFound = false;
              		for(let i=0; i<this.Form.transactionTypeList.length; i++){
              			if(this.Form.transactionTypeList[i].transactionTypeFormId == transactionTypeFormId){
              				itemFound = true;
              				this.fn_setTransactionType(this.Form.transactionTypeList[i], true);
              				break;
              			}
              		}

              		if(!itemFound){
              			if(this.Form.transactionTypeList.length == 1){
	  						this.fn_setTransactionType(this.Form.transactionTypeList[0], true);
	  					}
	  					else{
	  						let defaultTransactionType = this.Form.transactionTypeList.filter(item=>{
	  							return item.isDefault;
	  						})
	  						
	  						this.fn_setTransactionType(defaultTransactionType, callback, true);
	  					}
              		}
  				}
  				else{
  					if(this.Form.transactionTypeList.length == 1){
  						this.fn_setTransactionType(this.Form.transactionTypeList[0], true);
  					}
  					else{
  						// this.fn_openTransactionTypeList();
  						//transacion mixin function
  						// this.loading = false;
						// this.fn_openTransacionTypeList_onFormLoad();

						for(let i=0;i<this.Form.transactionTypeList.length; i++){
  							if(this.Form.transactionTypeList[i].isDefault){
  								this.fn_setTransactionType(this.Form.transactionTypeList[i], true);
  								break;
  							}
  						}
  					}
              		// this.Form.transactionTypeList.length == 1 ? this.fn_setTransactionType(this.Form.transactionTypeList[0]) : '';
              	}
		    },

			fn_saveFields: function (fieldsObj) {
				let data = JSON.parse(JSON.stringify(fieldsObj));

				console.log(JSON.stringify(data));

				//finding if details already exist
				let itemIndex = this.Form.customFields.findIndex(item=>{
					return item.section.sectionId == data.section.sectionId;
				})

				if(itemIndex==-1){
					this.Form.customFields.push(data);
				}
				else{
					this.Form.customFields[itemIndex] = data;
					this.$forceUpdate();
				}

				// let self = this;
				// setTimeout(function () {
				// 	self.$vuetify.goTo('#section_'+data.section.sectionId, self.scrollOptions);
				// 	let index = itemIndex != -1 ? itemIndex : self.Form.customFields.length-1
				// 	self.fn_showHideDynamicFieldOption(index, true);
				// },100)
				let self = this;
				setTimeout(function () {
					self.$vuetify.goTo('#section_'+data.section.sectionId, self.scrollOptions);

					if(data.section.sectionId == self.ewayBillDetailSection.sectionId){
						self.Form.hideEwayOption = true;
					}
					else{
						let index = itemIndex != -1 ? itemIndex : self.Form.customFields.length-1
						self.fn_showHideDynamicFieldOption(index, true);
					}
				},100)
				this.fn_closeDialog();
			},

			fn_removeFields: function (index, sectionId) {
				if(this.ewayBillDetailSection.sectionId == sectionId){
					this.Form.hideEwayOption = false;
				}
				else{
					this.fn_showHideDynamicFieldOption(index, false);
				}
				this.Form.customFields.splice(index, 1);
			},

			fn_showHideDynamicFieldOption: function(index, hideOption){
				for(let j=0; j<this.Form.dynamicMenuItems.length; j++){
					if(this.Form.dynamicMenuItems[j].sectionId == this.Form.customFields[index].section.sectionId){
						this.Form.dynamicMenuItems[j].hideOption = hideOption;
						this.$forceUpdate();
					}
				}
			},

			fn_openConfirmationDialog: function (msg) {
				this.confirmationMessage = msg;
				this.fn_openDialogWeb('web', 'confirmationDialog', 'ref_dialogChangeTransactionType');
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){

				if(ref.indexOf('dialog') != -1){
					// if(ref=='ref_dialogAddOns_name' && this.Form.newSelection){
					if(ref=='ref_dialogAddOns_name' && localStorage.getItem('newSelection')){
						this.fn_closeDialog();
						let self = this;
						setTimeout(() => {
							let dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
							if(!dialogData || (dialogData && dialogData[0].ref != "ref_dialogAddOns")){
								self.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns')	
							}
							// self.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns');
						}, 300);
						setTimeout(() => {
							self.fn_updateDialogRef(tagId, ref, selectedValueId, selectedValueName, isRemoved);
						}, 600);
					}
					// else if(ref=="ref_dialogProduct_productName" && this.Form.newSelection){
					else if(ref=="ref_dialogProduct_productName" && localStorage.getItem('newSelection')){
						this.fn_closeDialog();
						let self = this;
						setTimeout(() => {
							let dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
							if(!dialogData || (dialogData && dialogData[0].ref != "ref_dialogProduct")){
								// self.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct')	
								self.fn_openDialogProductForm();
							}
							// self.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct');
						}, 300);
						setTimeout(() => {
							self.fn_updateDialogRef(tagId, ref, selectedValueId, selectedValueName, isRemoved);
						}, 600);
					}
					else{
						this.fn_updateDialogRef(tagId, ref, selectedValueId, selectedValueName, isRemoved);
					}
					// let key = ref.substring(0, ref.lastIndexOf('_'));
					// let dialogRef = this.$refs[key];
		
					// var checkRefs = setInterval(function(){
			        //   if(dialogRef.$refs.hasOwnProperty(ref)){
			        //   	clearInterval(checkRefs);
			        //   	if(Array.isArray(dialogRef.$refs[ref])){
			        //   		dialogRef.$refs[ref][0].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved, ref);
			        //   	}
			        //   	else{
			        //   		dialogRef.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved, ref);
			        //   	}
			        //   }
			        // },50);
				}
				else{
					this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
				}
			},

			fn_openStates: function(){
				this.fn_openStateDialog('android', 'state', 'ref_fieldState');
			},

			fn_openStateDialog: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select State/Place of Supply";
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.placeOfSupplyId && this.Form.placeOfSupplyName){
					paramObject.defaultValue = {"id":this.Form.placeOfSupplyId, "name":this.Form.placeOfSupplyName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'state', tagId, paramObject, ref);
			},

			fn_updateState: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.placeOfSupplyId = selectedValueId;
		        	this.Form.placeOfSupplyName = selectedValueName;
		        	this.errors.remove('state');
				}
				else{
					this.Form.placeOfSupplyId = null;
		        	this.Form.placeOfSupplyName = null;
				}
				this.$forceUpdate();

				let oldGstType = this.Form.gstType ? this.Form.gstType : null;

				let partyGstType = null;
				// setting up default gst type to consumer in case of cash expense
				// if(this.Form.isCashTransaction){
				if(this.Form.isCashTransaction){
					partyGstType = 104;
				}
				else{
					partyGstType = this.Form.partyDetails && this.Form.partyDetails.gstType ? this.Form.partyDetails.gstType : 104;
				}

				if(this.Form.gstType != this.$root.fn_getGstType(this.Form.placeOfSupplyId, partyGstType)){
		          	this.Form.gstType = this.$root.fn_getGstType(this.Form.placeOfSupplyId, partyGstType);
		          	this.fn_bindGstAddOns();
		        }

		        if(oldGstType && oldGstType != this.Form.gstType){
		        	this.fn_removeAddOnsOnPlaceOfSupplyChange(fixedGstAddOns);	
		        }
			},

			fn_openSuppliers: function () {

				if(this.Form.isCashTransaction){
					return;
				}

				let accountGroups = [];
				if(this.Form.transactionTypeData && !this.Form.transactionTypeData.isAllPartySelected){
					this.Form.transactionTypeData.transactionParties.forEach(function (item) {
						accountGroups.push(item.accountGroupId);
					});
				}
				this.fn_openAccountLedgers('android', 'Supplier', 'ref_fieldSupplier', this.Form.partyId, this.Form.partyName, accountGroups);
			},

			// fn_confirm: function () {
			// 	this.fn_closeDialog();
			// 	this.fn_openTransactionTypeList();
			// },

			fn_openTransactionTypeList: function () {
				this.fn_openDialogWeb('web', 'TransactionTypeList', 'ref_dialogTransactionTypeList');	
			},

			fn_openTaxCategories: function(){
				this.fn_openDialogWeb('web', 'TaxCategories', 'ref_dialogTaxCategories');
			},

			fn_getTaxCategories: function(){
			  let filterObject = {};
			  let self = this;
			  this.getItems("TaxCategoryList", filterObject, 
			    {
			      onSuccess: function (response) {
			        console.log(response);
			        self.unwatch = true;
			        self.taxCategories = JSON.parse(response);
			      },
			      onError: function (error) {
			        console.log(error);
			      }
			    }
			  )
			},

			fn_addItem: function (isNew) {

				if(this.Form.transactionTypeList && this.Form.transactionTypeList.length>1){
					if(!this.Form.transactionTypeFormName){
						this.showToast("Select transaction form");
					}
					else{
						this.fn_addNewItem(isNew);
					}
				}
				else{
					this.fn_addNewItem(isNew);
				}

				// this.$validator.validate('supplier').then((result)=>{
				// 	if(result){

				// 		if(this.Form.transactionTypeList && this.Form.transactionTypeList.length>1){
				// 			if(!this.Form.transactionTypeFormName){
				// 				this.showToast("Select transaction form");
				// 				// this.$vuetify.goTo('#transactionTypeField', this.scrollOptions);
				// 			}
				// 			else{
				// 				this.fn_addNewItem(isNew);
				// 			}
				// 		}
				// 		else{
				// 			this.fn_addNewItem(isNew);
				// 		}

				// 	}
				// 	else{
				// 		this.$vuetify.goTo('#supplierfield', this.scrollOptions);
				// 	}
				// });
				
			},

			fn_addNewItem: function(isNew, doneAndNew){
				if(isNew){
					// this.Form.newSelection = true;
					localStorage.setItem('newSelection', 1)
					// this.Form.productDataModel = {"groupId":null, "productId":null, "groupTypeId":null, "productName":null, "mrp":null, "rate":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "cessAmount":0, "taxCategoryId": null, "taxCategoryName": null, 
					// 	"defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null, "description":null};

					this.fn_bindTransactionTypeAddOns();

					// let self = this;
					// setTimeout(function(){
					// 	self.fn_openProducts('android', 'Products', 'ref_dialogProduct_productName', self.Form.productDataModel.productId, self.Form.productDataModel.productName);
					// },400);
					this.fn_openProducts('android', 'Products', 'ref_dialogProduct_productName', null, null);
				}
				else{
					// this.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct');
					this.fn_openDialogProductForm();
				}

				// if(!doneAndNew){
				// 	this.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct');	
				// }
			},

			fn_openDialogProductForm: function(){
				// if(this.Form.newSelection){
				if(localStorage.getItem('newSelection')){
					this.Form.productDataModel = {"groupId":null, "productId":null, "groupTypeId":null, "productName":null, "mrp":null, "rate":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "cessAmount":0, "taxCategoryId": null, "taxCategoryName": null, 
						"defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null, "description":null};

					this.fn_bindTransactionTypeAddOns();
				}
				this.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct');
			},

			fn_openTdsForm: function () {
				if(this.Form.tdsDetails){
					this.Form.tdsDataModel = JSON.parse(JSON.stringify(this.Form.tdsDetails));
				}
				else{
					this.Form.tdsDataModel = {"transactionTdsId":null, "transactionId":null, "tdsAccountId":null, "tdsAccountName":null, "appliedOnAmount":null, "percentage":null, "amount":null
					}
				}
				this.fn_openDialogWeb('web', 'TDS', 'ref_dialogTds');
			},

			fn_openAddOns: function (addOnsType, isNew) {

				// this.Form.addOnsProp.value = "addOns";
				// this.Form.addOnsProp.toolbarTitle = "Discounts/Taxes/Other Charges";

				// this.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns');	

				if(isNew){
					// this.Form.newSelection = true;
					localStorage.setItem('newSelection', 1);
					this.Form.addOnsDataModel = {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":addOnsType};

					this.fn_openAddOnsList('android', 'AddOns', 'ref_dialogAddOns_name', null, null, addOnsType);
				}
				else{
					this.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns');
				}
			},

			fn_openDatePicker: function (type, date) {
				let self = this;
				this.dateType = type;
				// this.selectedDate = date ? date : new Date();
				this.selectedDate = date ? date : this.$root.fn_getLocalDateFormat();
				setTimeout(function () {
					self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker');
				})
			},

			fn_updateDate: function (value) {
				if(this.dateType=="transactionDate"){
					// this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(value);
                    // if(this.Form.isNew){
                    //     this.fn_bindTransactionNumber();
                    // }
					this.fn_updateTransactionDate(value, this.Form.isNew);
				}
				else if(this.dateType=="refDate"){
					this.Form.transactionData.refDate = this.$root.fn_getLocalDateFormat(value);
				}
				// else if(this.dateType=="dynamicFieldDate"){
				else if(this.dateType.indexOf("dynamicFieldDate") != -1){
					this.$refs['ref_dialogDynamicFields'].fn_updateDynamicDate(value, this.dateType);
				}

				this.fn_closeDialog();
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			// fn_openAccountLedgers: function (platform, name, ref, itemId, itemName, accountGroups) {

			// 	let viewDialogObject = { ToolbarTitle:"Ledger", groupTypeId:null, action:null, accountGroups:null };
			// 	viewDialogObject.ToolbarTitle = ref == 'ref_fieldSupplier' ? 'Supplier' : "Ledger";
			// 	viewDialogObject.selectedItem = {itemId:itemId, itemName:itemName};
			// 	viewDialogObject.ref = ref;

			// 	if(name == 'Supplier'){
			// 		viewDialogObject.action = "newsupplier";
			// 		viewDialogObject.groupTypeId = 102;
			// 	}
			// 	else if(name == "TdsAccounts"){
			// 		viewDialogObject.action = "newledger"
			// 	}
			// 	else if(name == 'AccountLedgers'){
			// 		viewDialogObject.action = "dynamicAccountField";
			// 	}

			// 	if(accountGroups && accountGroups.length){
			// 		viewDialogObject.accountGroups = JSON.parse(JSON.stringify(accountGroups));
			// 	}

			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.$nextTick(() => {
			// 		this.fn_openDialogWeb('web', 'Ledger', 'ref_dialogLedger');
			// 	})
			// },

			fn_openAccountLedgers: function (platform, name, ref, itemId, itemName, accountGroups) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = ref == 'ref_fieldSupplier' ? 'Select Supplier' : "Select Ledger";

				let action = "newledger";

				if(name == 'Supplier'){
					// viewDialogObject.groupTypeId = ledgerGroupTypeId.supplier;
					action = "newsupplier";
				}

				this.Form.dynamicFields.accountGroupId ? action = "dynamicAccountField" : "";

				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":action};
				viewDialogObject.TopMenu = [menuItemCustom];
				viewDialogObject.isBottomMenu = false;
				// viewDialogObject.accountGroups = [];
				// viewDialogObject.accountGroupIds = [];

				if(accountGroups && accountGroups.length){
					// viewDialogObject.accountGroupIds = JSON.parse(JSON.stringify(accountGroups));
					viewDialogObject.accountGroups = JSON.parse(JSON.stringify(accountGroups));
				}

				if(ref=='ref_expenseLedger'){
					viewDialogObject.accountGroups = [accountGroupIds.indirectExpense.id, accountGroupIds.directExpense.id, accountGroupIds.fixedAssets.id];
				}

				viewDialogObject.accountGroupsHidden = [accountGroupIds.brokers.id];

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
			},

			// fn_openExpenseCategories: function(platform, name, ref){

			// 	let viewDialogObject = { ToolbarTitle:"Expense Category", fnName:"ExpenseCategoryDialog", action:"newexpensecategory", ref:ref, dbSearch:true };

			// 	if(this.Form.expenseCategoryId && this.Form.expenseCategoryName){
			// 		viewDialogObject.selectedItem = {"itemId":this.Form.expenseCategoryId, "itemName":this.Form.expenseCategoryName};
			// 	}

			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'Account Group', 'ref_dialogSelectionList');
			// },

			fn_openExpenseCategories: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Expense Category";
				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":"newexpensecategory"};
				viewDialogObject.TopMenu = [menuItemCustom];
				viewDialogObject.hideChip = true;

				var paramObject = {};
				paramObject.defaultValue = {"id":this.Form.expenseCategoryId, "name":this.Form.expenseCategoryName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'expenseCategory', tagId, paramObject, ref);
			},

			fn_updateExpenseCategory: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.expenseCategoryId = selectedValueId;
		        	this.Form.expenseCategoryName = selectedValueName;
		        	this.fn_getExpenseCategoryData(selectedValueId);
		        	this.$forceUpdate();
		        	this.errors.remove('expenseCategory');
				}
				else{
					this.Form.expenseCategoryId = null;
		        	this.Form.expenseCategoryName = null;
				}
			},

			fn_getExpenseCategoryData: function(itemId){
				var self = this;
				this.getData('ExpenseCategory', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							self.Form.expenseData.accountLedgerId = data.accountLedgerId;
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			// fn_openProducts: function () {
			// 	if(this.$refs['ref_dialogProduct'] && !this.$refs['ref_dialogProduct'].dialog_product){
			// 		this.Form.productDataModel.productId = null;
			// 		this.Form.productDataModel.productName = null;
			// 	// 	this.Form.productDataModel = {"groupId":null, "productId":null, "groupTypeId":null, "productName":null, "mrp":null, "rate":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "cessAmount":0, "taxCategoryId": null, "taxCategoryName": null, 
			// 	// 		"defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null, "description":null};
			// 	}

			// 	let viewDialogObject = {
			// 		ToolbarTitle:"Item", 
			// 		action:"newproduct",
			// 		inventory:0,
			// 		selectedItem:{itemId:this.Form.productDataModel.productId, itemName:this.Form.productDataModel.productName}
			// 	};

			// 	localStorage.setItem("dialog_properties", JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'Products', 'ref_dialogProductList');
			// },

			fn_openProducts: function (platform, name, ref, itemId, itemName) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Item";

				viewDialogObject.inventory = 0;

				// let action = null;

				// if(this.Form.invoiceType==0){
				// 	viewDialogObject.groupTypeId = productGroupTypeId.product;
				// 	action = "newproduct";
				// }
				// else{
				// 	viewDialogObject.groupTypeId = productGroupTypeId.service;
				// 	action = "newservice";
				// }

				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":"newproduct"};
				viewDialogObject.TopMenu = [menuItemCustom];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'product', tagId, paramObject, ref);
			},

			fn_openListItems: function (platform, name, ref, itemId, itemName, listId, listName) {

				this.Form.dynamicFieldsAdditionalData.listId = listId;
				this.Form.dynamicFieldsAdditionalData.listName = listName;

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Item";
				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":"newListItem"};
				viewDialogObject.TopMenu = [menuItemCustom];

				viewDialogObject.isBottomMenu = false;
				viewDialogObject.listId = listId;

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'listItems', tagId, paramObject, ref);
			},

			// fn_openAddOnsList: function(platform, name, ref, itemId, itemName, addOnsType){

			// 	let viewDialogObject = { ToolbarTitle:"Add On", fnName:"AddOnsDialog", ref:ref, dbSearch:true };

			// 	viewDialogObject.addOnType = addOnsType;
			// 	// let actionValue = null;
			// 	if(addOnsType == 1){
			// 		this.Form.addOnsProp.toolbarTitle = "Discounts";
			// 		viewDialogObject.action = "adddiscount";
			// 	}
			// 	else if(addOnsType == 2){
			// 		this.Form.addOnsProp.toolbarTitle = "Taxes";
			// 		viewDialogObject.action = "addtaxes";
			// 	}
			// 	else{
			// 		this.Form.addOnsProp.toolbarTitle = "Other Charges";
			// 		viewDialogObject.action = "addothercharges";	
			// 	}

			// 	viewDialogObject.ToolbarTitle = this.Form.addOnsProp.toolbarTitle;

			// 	if(itemId && itemName){
			// 		viewDialogObject.selectedItem = {"itemId":itemId, "itemName":itemName};
			// 	}

			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'Account Group', 'ref_dialogSelectionList');
			// },

			fn_openAddOnsList: function (platform, name, ref, itemId, itemName, addOnsType) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};
				// viewDialogObject.ToolbarTitle = this.Form.addOnsProp.toolbarTitle;
				// let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":this.Form.addOnsProp.value};
				this.Form.addOnsProp.addOnsType = addOnsType;

				// let actionValue = null;
				if(addOnsType == 1){
					this.Form.addOnsProp.toolbarTitle = "Discounts";
					viewDialogObject.TopMenu = [menuItem.addDiscount];
					// actionValue = "adddiscount";
				}
				else if(addOnsType == 2){
					this.Form.addOnsProp.toolbarTitle = "Taxes";
					viewDialogObject.TopMenu = [menuItem.addTaxes];
					// actionValue = "addtaxes";
				}
				else{
					this.Form.addOnsProp.toolbarTitle = "Other Charges";
					viewDialogObject.TopMenu = [menuItem.addOtherCharges];	
					// actionValue = "addothercharges";
				}

				viewDialogObject.ToolbarTitle = this.Form.addOnsProp.toolbarTitle;

				// viewDialogObject.TopMenu = [menuItemCustom];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;
				viewDialogObject.addOnType = Number(addOnsType);

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, "addOns", tagId, paramObject, ref);
			},

			fn_saveAddOns: function (data) {

				// this.Form.newSelection = false;
				localStorage.removeItem('newSelection')
				if(data.mode==0 && (data.percentage==null || data.percentage=='')){
					data.value = null;
				}

				if(!data.isDefault)
					data.isDefault = false;

				!data.transactionAddOnsId ? data.transactionAddOnsId = this.guid() : '';

				let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
					return item.transactionAddOnsId == data.transactionAddOnsId;
				});

				// if(itemIndex==-1){
				// 	this.Form.transactionAddOns.push(data);
				// }
				// else{
				// 	this.Form.transactionAddOns.splice(itemIndex, 1, data);
				// }

				// this.fn_closeDialog();

				if(data.addOnsType == 2){
					this.fn_checkTaxAddOns(data);
				}
				else{
					let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
						return item.transactionAddOnsId == data.transactionAddOnsId || item.addOnsId == data.addOnsId;
					});

					if(itemIndex==-1){
						this.Form.transactionAddOns.push(data);
					}
					else{
						this.Form.transactionAddOns.splice(itemIndex, 1, data);
					}

					this.fn_closeDialog();
				}
			},

			fn_checkTaxAddOns: function(data){
				let data2 = null
				if(this.Form.gstType == "IntraState" && (fixedGstAddOns.CGST.id == data.addOnsId || fixedGstAddOns.SGST.id == data.addOnsId)){
					data2 = JSON.parse(JSON.stringify(data));
					data2.transactionAddOnsId = this.guid();
					if(fixedGstAddOns.CGST.id == data.addOnsId){
						data2.addOnsId = fixedGstAddOns.SGST.id;
						data2.purchaseAccountItemId = fixedAccountIds.sgst.id;
						this.Form.isRcmApplicable ? data2.saleAccountItemId = fixedAccountIds.sgst.id : '';
						data2.name = "SGST";
						
						// if(this.Form.isRcmApplicable){
						// 	data2.saleAccountItemId = fixedAccountIds.sgst.id;
						// 	data2.purchaseAccountItemId = fixedAccountIds.sgst.id;
						// }
						// else{
						// 	data2.purchaseAccountItemId = fixedAccountIds.sgst.id;
						// }
						// data2.name = "SGST";
					}
					else{
						data2.addOnsId = fixedGstAddOns.CGST.id;
						data2.purchaseAccountItemId = fixedAccountIds.cgst.id;
						this.Form.isRcmApplicable ? data2.saleAccountItemId = fixedAccountIds.cgst.id : '';
						data2.name = "CGST";

						// if(this.Form.isRcmApplicable){
							
						// 	data2.saleAccountItemId = fixedAccountIds.cgst.id;
						// 	data2.purchaseAccountItemId = fixedAccountIds.cgst.id;
						// }
						// else{
						// 	data2.purchaseAccountItemId = fixedAccountIds.cgst.id;
						// }
						// data2.name = "CGST";
					}
				}
				else if(this.Form.gstType == "UnionTerritory" && (fixedGstAddOns.CGST.id == data.addOnsId || fixedGstAddOns.UTGST.id == data.addOnsId)){
					data2 = JSON.parse(JSON.stringify(data));
					data2.transactionAddOnsId = this.guid();
					if(fixedGstAddOns.CGST.id == data.addOnsId){
						data2.addOnsId = fixedGstAddOns.UTGST.id;
						data2.purchaseAccountItemId = fixedAccountIds.utgst.id;
						this.Form.isRcmApplicable ? data2.saleAccountItemId = fixedAccountIds.utgst.id : '';
						data2.name = "UTGST";
						
						// if(this.Form.isRcmApplicable){
						// 	data2.saleAccountItemId = fixedAccountIds.utgst.id;
						// 	data2.purchaseAccountItemId = fixedAccountIds.utgst.id;
						// }
						// else{
						// 	data2.purchaseAccountItemId = fixedAccountIds.utgst.id;
						// }
						// data2.name = "UTGST";
					}
					else{
						data2.addOnsId = fixedGstAddOns.CGST.id;
						data2.purchaseAccountItemId = fixedAccountIds.cgst.id;
						this.Form.isRcmApplicable ? data2.saleAccountItemId = fixedAccountIds.cgst.id : '';
						data2.name = "CGST";
						
						// if(this.Form.isRcmApplicable){
						// 	data2.saleAccountItemId = fixedAccountIds.cgst.id;
						// 	data2.purchaseAccountItemId = fixedAccountIds.cgst.id;
						// }
						// else{
						// 	data2.purchaseAccountItemId = fixedAccountIds.cgst.id;
						// }
						// data2.name = "CGST";
					}
				}

				let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
					return item.transactionAddOnsId == data.transactionAddOnsId || item.addOnsId == data.addOnsId;
				});

				if(itemIndex==-1){
					this.Form.transactionAddOns.push(data);
				}
				else{
					this.Form.transactionAddOns.splice(itemIndex, 1, data);
				}

				if(data2){
					let data2Index = this.Form.transactionAddOns.findIndex(item=>{
						return item.addOnsId == data2.addOnsId;
					});

					if(data2Index==-1){
						this.Form.transactionAddOns.push(data2);
					}
					else{
						this.Form.transactionAddOns.splice(data2Index, 1, data2);
					}
				}

				this.fn_closeDialog();

			},

			fn_removeAddOns: function(item, index){
				let addOnIndex = this.Form.transactionAddOns.findIndex(addOnItem=>{
					return item.transactionAddOnsId == addOnItem.transactionAddOnsId;
				})

				// this.Form.transactionAddOns.splice(index, 1);
				this.Form.transactionAddOns.splice(addOnIndex, 1);

				if(item.addOnsId == fixedGstAddOns.CGST.id){
					let self = this;
					if(this.Form.gstType == "UnionTerritory"){
						this.fn_removeAddOnsPair(fixedGstAddOns.UTGST.id)
					}
					else{
						this.fn_removeAddOnsPair(fixedGstAddOns.SGST.id)	
					}
				}
				else if(item.addOnsId == fixedGstAddOns.SGST.id || item.addOnsId == fixedGstAddOns.UTGST.id){
					this.fn_removeAddOnsPair(fixedGstAddOns.CGST.id)
				}
			},

			fn_removeAddOnsPair: function(addOnId){
				let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
					return item.addOnsId == addOnId;
				})

				this.Form.transactionAddOns.splice(itemIndex, 1);
			},

			fn_editAddOns: function (item) {
				// this.Form.newSelection = false;
				localStorage.removeItem('newSelection');
				this.Form.addOnsDataModel = JSON.parse(JSON.stringify(item));
				this.fn_openAddOns(item.addOnsType);
			},

			// fn_setProductTaxValue: function (item) {
			// 	this.Form.productDataModel.taxValue = item.value;
			// 	this.fn_closeDialog();
			// },

			fn_updateTaxCategory: function (item, preventCloseDialog) {
				this.Form.productDataModel.taxValue = item.taxValue;
				this.Form.productDataModel.cessValue = item.cessValue;
				this.Form.productDataModel.taxCategoryId = item.taxCategoryId;
				this.Form.productDataModel.taxCategoryName = item.taxCategoryName;
				this.Form.productDataModel.isCessApplicable = item.isCessApplicable;
				this.$forceUpdate();
				!preventCloseDialog ? this.fn_closeDialog() : '';

				this.fn_checkTaxCategory();
				// if(this.fn_isNewTaxForm() && !localStorage.getItem('hide_old_tax_message')){
				// 	let taxPer = this.Form.productDataModel.taxValue;
				// 	if(taxPer != 5 && taxPer != 18 && taxPer != 40 && taxPer != 3 && taxPer != 0.25 && taxPer != 1.5){
				// 		// this.$parent.snackbarTaxCategory = true;
				// 		this.fn_openDialogWeb('web', 'OldTaxUpdate', 'ref_dialogOldTaxUpdate');
				// 		this.$refs['ref_dialogProduct'].disableBtn = false;
				// 	}
				// }
			},

			fn_checkTaxCategory: function(){
				if(this.fn_isNewTaxForm() && !localStorage.getItem('hide_old_tax_message')){
					let taxPer = this.Form.productDataModel.taxValue;
					if(taxPer != null && taxPer != 0 && taxPer != 5 && taxPer != 18 && taxPer != 40 && taxPer != 3 && taxPer != 0.25 && taxPer != 1.5){
						// this.$parent.snackbarTaxCategory = true;
						this.fn_openDialogWeb('web', 'OldTaxUpdate', 'ref_dialogOldTaxUpdate');
						this.$refs['ref_dialogProduct'].disableBtn = false;
					}
				}
			},

			// fn_openExpenseLedgers: function () {
			// 	this.ledgerType = 'expenseLedger'
			// 	this.fn_openAccountLedgers('android', 'Expense', 'ref_expenseLedger', this.Form.expenseData.accountLedgerId, this.Form.expenseData.accountLedgerName);
			// },

			// fn_updateExpenseLedger: function (selectedValueId, selectedValueName, isRemoved) {
			// 	if(!isRemoved){
			// 		this.Form.expenseData.accountLedgerId = selectedValueId;
		 //        	this.Form.expenseData.accountLedgerName = selectedValueName;
		 //        	this.$forceUpdate();
		 //        	this.errors.remove('expenseLedger');
		 //        	this.fn_validateParty(null)
			// 	}
			// 	else{
			// 		this.Form.expenseData.accountLedgerId = null;
		 //        	this.Form.expenseData.accountLedgerName = null;
			// 	}
			// },

			fn_saveItem: function (data, doneAndNew) {
				let itemIndex = null;

				let itemData = JSON.parse(JSON.stringify(data));

				!itemData.mrp ? itemData.mrp = 0 : '';
				!itemData.rate ? itemData.rate = 0 : '';

				if(!itemData.groupId){
					itemData.groupId = this.guid();
					this.Form.items.push(itemData);
				}
				else{
					itemIndex = this.Form.items.findIndex(item=>{
						return item.groupId == itemData.groupId;
					})
					this.Form.items.splice(itemIndex, 1, itemData);
				}

				this.fn_closeDialog();

				localStorage.removeItem('newSelection');
				
				if(doneAndNew){
					this.showToast("Item added");
					this.fn_addNewItem(true, doneAndNew);
				}
				// else{
				// 	this.fn_closeDialog();
				// }

				// this.Form.newSelection = false;
				localStorage.removeItem('newSelection');
				this.fn_removeTaxAddons();

				let self = this;
				setTimeout(function(){
					self.$refs['ref_dialogProduct'].disableBtn = false;	
				},1000);
			},

			fn_editItem: function (item) {

				// this.Form.newSelection = false;
				localStorage.removeItem('newSelection');
				let itemData = JSON.parse(JSON.stringify(item));
				this.Form.productDataModel.groupId = itemData.groupId;
				this.Form.productDataModel.productId = itemData.productId;
				this.Form.productDataModel.groupTypeId = itemData.groupTypeId;
				this.Form.productDataModel.productName = itemData.productName;
				this.Form.productDataModel.mrp = itemData.mrp;
				this.Form.productDataModel.rate = itemData.rate;
				this.Form.productDataModel.productVariants = itemData.productVariants;
				this.Form.productDataModel.taxValue = itemData.taxValue;
				this.Form.productDataModel.taxAmount = itemData.taxAmount;
				this.Form.productDataModel.description = itemData.description;

				this.Form.productDataModel.cessValue = itemData.cessValue >= 0 ? itemData.cessValue : null;
				this.Form.productDataModel.cessAmount = itemData.cessAmount ? itemData.cessAmount : 0;

				this.Form.productDataModel.taxCategoryId = itemData.taxCategoryId;
				this.Form.productDataModel.taxCategoryName = itemData.taxCategoryName;

				this.Form.productDataModel.hsnCode = itemData.hsnCode;
				this.Form.productDataModel.orderNumber = itemData.orderNumber;
				this.Form.productDataModel.grossAmount = itemData.grossAmount;
				this.Form.productDataModel.grossAmountAsPerMRP = itemData.grossAmountAsPerMRP;
				this.Form.productDataModel.netAmount = itemData.netAmount;

				this.Form.productDataModel.defaultTaxValue = itemData.defaultTaxValue;
				this.Form.productDataModel.defaultCessValue = itemData.defaultCessValue;
				this.Form.productDataModel.defaultHsnCode = itemData.defaultHsnCode;
				this.Form.productDataModel.defaultTaxCategoryId = itemData.defaultTaxCategoryId;
				this.Form.productDataModel.defaultTaxCategoryName = itemData.defaultTaxCategoryName;
				this.Form.productDataModel.isCessApplicable = itemData.isCessApplicable;

				// this.Form.productDataModel.defaultTaxValue = itemData.defaultTaxValue;

				this.$refs['ref_dialogProduct'].fn_getProductData(true, itemData.productId, itemData.baseTransactionListId);

				this.fn_refreshAddons(itemData);
			},

			fn_removeItem: function(itemIndex, groupId){
				if(itemIndex){
					this.Form.items.splice(itemIndex, 1);
				}
				else{
					let index = this.Form.items.findIndex(item=>{
						return item.groupId == groupId;
					});
					this.Form.items.splice(index, 1);
					this.fn_closeDialog();
				}
			},

			fn_refreshAddons: function (itemData) {

      			let defaultAddons = this.Form.productDataModel.addOnsItems;

      			for(let i=0; i<defaultAddons.length; i++){

      				let shared = false;

      				for(let j=0; j<itemData.addOnsItems.length; j++){
      					if (itemData.addOnsItems[j].addOnsId == defaultAddons[i].addOnsId) {
				   			defaultAddons[i].percentage = itemData.addOnsItems[j].percentage;
				   			defaultAddons[i].value = itemData.addOnsItems[j].value;

				   			if(this.Form.transactionData.transactionId){
				   				defaultAddons[i].transactionProductsAddOnsId = itemData.addOnsItems[j].transactionProductsAddOnsId;
				   			}

				   			shared = true;
				           	break;
				       }
      				}

      				if(!shared){
      					defaultAddons[i].percentage = null;
				   		defaultAddons[i].value = null;
      				}

      			}

				this.fn_addItem();
			},

			fn_saveTdsDetails: function (data) {
				data.transactionTdsId = this.guid();
				this.Form.tdsDetails = JSON.parse(JSON.stringify(data));
				this.fn_closeDialog();
			},

			fn_removeTds: function(){
				this.Form.tdsDetails = {"amount":null};
				this.fn_closeDialog();
			},

			fn_updateSupplier: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.partyId = selectedValueId;
		        	this.Form.partyName = selectedValueName;
		        	this.fn_getPartyDetails(selectedValueId, true);

		        	if(this.Form.transactionTypeData){
		        		this.fn_validateParty(this.Form.transactionTypeData.transactionParties);
		        	}

		        	this.$forceUpdate();
		        	this.errors.remove('supplier');
				}
				else{
					this.Form.partyId = null;
		        	this.Form.partyName = null;
				}
			},

			fn_getPartyDetails: function (partyId, bindPlaceofSupply) {
				var self = this;
		  		this.getData('Ledger', partyId, 
					{
						onSuccess: function(response){

				            console.log(response);

					        // let partyDetails = JSON.parse(response);
					        self.Form.partyDetails = JSON.parse(response);

					        // self.Form.partyGstType = partyDetails.gstType;

					        // if(self.$root.CurrentBusiness.GSTRegistrationStatus==1 && bindPlaceofSupply){
					        if(bindPlaceofSupply){
					        	let placeOfSupplyId = self.Form.partyDetails.placeOfSupplyId ? self.Form.partyDetails.placeOfSupplyId : self.$root.CurrentBusiness.StateID;

					        	let placeOfSupplyName = self.Form.partyDetails.placeOfSupply ? self.Form.partyDetails.placeOfSupply : self.$root.CurrentBusiness.State;

					        	if(self.Form.partyDetails.countryId && self.Form.partyDetails.country){
					        		placeOfSupplyId = null;
					        		placeOfSupplyName = null;
					        	}

					        	self.Form.placeOfSupplyCountryId = self.Form.partyDetails.countryId;
					        	self.Form.placeOfSupplyCountryName = self.Form.partyDetails.country;

					        	self.fn_updateState(placeOfSupplyId, placeOfSupplyName, false);

					        }

				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getDefaultGstAddOns: function () {
				let self = this;
				this.Form.defaultTaxAddOns = [];

				for(let key in fixedGstAddOns){
					(function (itemId) {
				  		self.getData('AddOns', itemId, 
							{
								onSuccess: function(response){
						          console.log(response);

						          let itemIndex = self.Form.defaultTaxAddOns.findIndex(item=>{
						          	return item.addOnsId == itemId;
						          });

						          if(itemIndex==-1){
						          	self.unwatch = true;
						          	self.Form.defaultTaxAddOns.push(JSON.parse(response));
						          }

						        }, 
						        onError: function(error){
						          console.log(error);
						        }
							}
				        );
					}(fixedGstAddOns[key].id));
				}
			},

			fn_getDefaultCessAddOns: function () {
				let self = this;

				self.getData('AddOns', fixedCessAddOns.CESS.id, {

					onSuccess: function(response){
			          console.log(response);
			          self.unwatch = true;
			          self.Form.cessAddOns = JSON.parse(response);

			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				});
			},

			fn_bindGstAddOns: function () {

				let self = this;
				this.Form.gstAddOns = [];

				this.Form.defaultTaxAddOns.forEach(function (addOnsItem, index) {

					let taxAddOnsItem = JSON.parse(JSON.stringify(addOnsItem));
								
					taxAddOnsItem.percentage = 0;
      				taxAddOnsItem.value = 0;

      				if(self.Form.gstType == 'IntraState' && 
      					(fixedGstAddOns.CGST.id == taxAddOnsItem.addOnsId || fixedGstAddOns.SGST.id == taxAddOnsItem.addOnsId))
      				{
      					self.Form.gstAddOns.push(taxAddOnsItem);
      				}
      				else if(self.Form.gstType == 'InterState' && fixedGstAddOns.IGST.id == taxAddOnsItem.addOnsId){
      					self.Form.gstAddOns.push(taxAddOnsItem);
      				}
      				else if(self.Form.gstType == 'UnionTerritory' &&
      					(fixedGstAddOns.CGST.id == taxAddOnsItem.addOnsId || fixedGstAddOns.UTGST.id == taxAddOnsItem.addOnsId)){
      					self.Form.gstAddOns.push(taxAddOnsItem);
      				}
				});

				if(this.Form.items.length){
					this.fn_calculateTax();
				}
			},

			// fn_checkTransactionType: function (item) {
			// 	if(this.Form.transactionAddOns.length || this.Form.items.length || this.Form.customFields.length){
			// 		let msg = "In case of transaction type change, <b>Discounts/Taxes/Other Charges</b> and other details may change or remove."
			// 		this.fn_openConfirmationDialog(msg);
			// 	}
			// 	else{
			// 		this.fn_openTransactionTypeList();
			// 	}
			// },

			fn_setTransactionType: function (item, openParty) {
				let self = this;
				let transactionTypeSelected = this.Form.transactionTypeFormId ?  true : false;
				if(this.Form.transactionTypeFormId != item.transactionTypeFormId){

					// this.Form.items.forEach(function (itemData) {
					// 	itemData.addOnsItems = [];
					// 	(function (itemData) {
					// 		itemData.netAmount = self.$refs['ref_dialogProduct'].fn_computeValues(itemData);
					// 	}(itemData));
					// });

					// !dont remove as will be useful if transaction form open for user
					// this.Form.dynamicFields = {"section":null, "items":[], "accountGroupId":null, "accountGroupName":null};
					// this.Form.dynamicFieldsAdditionalData = {};
					// this.Form.customFields = [];
					// this.Form.dynamicMenuItems = [];

					this.fn_getTransactionTypeData(item.transactionTypeFormId, null, true);
				}

				this.Form.transactionTypeFormId = item.transactionTypeFormId;
				this.Form.transactionTypeFormName = item.name;

				localStorage.setItem(this.settings.transactionTypeId, item.transactionTypeFormId);

				// this.errors.remove('transactionType');
				this.$forceUpdate();
				this.fn_closeDialog();

				if(!transactionTypeSelected && this.Form.draftItems && this.Form.draftItems.length){
					this.loading = false;
					this.fn_openDialogDraftItems();
				}
				else if(!this.$root.CurrentBusiness.DataDrive && this.Form.isNew){
					this.fn_checkTransactionCount(()=>{
						if(this.transactionCount>=3 || this.fn_differenceOfDays() > 7){
							this.fn_openDialogDriveSetup();
						}
					})
				}
				// else{
				// 	if(!this.Form.inventory && !this.Form.partyName){
				// 		this.fn_openParties_onFormLoad(openParty, this.fn_openSuppliers);
				// 	}
				// }
				//transacion mixin function
				// this.fn_openParties_onFormLoad(openParty, this.fn_openSuppliers);

				// setTimeout(function(){
				// 	(openParty && !self.$route.query.dt) || !self.Form.partyId ? self.fn_openSuppliers() : '';
				// },500);
			},

			//updateNS = update number series
			fn_getTransactionTypeData: function(itemId, callback, updateNS, callingFrom){
				// this.showLoading('Please wait...');
				var self = this;
				// let transactionDate = this.Form.transactionData.transactionDate ? this.Form.transactionData.transactionDate : new Date();
				let transactionDate = this.Form.transactionData.transactionDate ? this.Form.transactionData.transactionDate : this.$root.fn_getLocalDateFormat();
				let filterObject = {};
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(transactionDate));
				this.getFilterData('TransactionTypeForm', itemId, filterObject,
					{
						onSuccess: function(response){
					        console.log(response);
					        self.Form.transactionTypeData = JSON.parse(response);

					        if(self.$root.CurrentBusiness.GSTRegistrationStatus!=1){
					        	self.Form.isItcEligible = false;
					        }

					        if(self.Form.isItcEligible){
					        	self.Form.savedItemData && self.Form.savedItemData.taxMode ? self.Form.taxMode = self.Form.savedItemData.taxMode : '';
					        	self.Form.isCashTransaction = false;
					        }
					        // else{
					        // 	self.Form.taxMode = 0;
					        // 	self.Form.isRcmApplicable = false;

					        // 	if(self.Form.isNew){
					        // 		if(callingFrom!='draft'){
					        // 			self.Form.isCashTransaction = true;
					        // 			self.fn_byCash(true);	
					        // 		}
					        // 		else{
					        // 			if(self.Form.isCashTransaction){
					        // 				self.fn_byCash(true);	
					        // 			}
					        // 		}
					        		
					        // 	}
					        // }

					        self.Form.transactionData.paymentMode = self.Form.transactionTypeData.paymentMode;

					         if(self.Form.transactionData.paymentMode == 1){
					        	self.fn_getPaymentGroups();
					        }
					        else{
					        	self.Form.splitPayment = false;
					        }

					        if(callingFrom == 'draft'){
					        	//refereshing transactiontype data if form is loaded from draft
					          	self.fn_refreshTransactionTypeData(self.Form.transactionTypeData);
					        }
					        else{
					        	self.fn_bindTransactionTypeData(callback, updateNS);
					        }
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_removeTaxAddons: function(){
				this.Form.transactionAddOns = this.Form.transactionAddOns.filter(item=>{
					return item.addOnsType != 2;
				});
			},

			//updateNS = update number series

			fn_bindTransactionTypeData: function (callback, updateNS) {
				
				updateNS && this.Form.isNew ? this.fn_bindTransactionNumber() : '';

				// this.fn_bindTransactionTypeAddOns(true, callback);
				this.fn_bindTransactionTypeAddOns(true);

				if(this.Form.partyId && this.Form.isNew && !this.Form.transactionTypeData.isAllPartySelected){
					this.fn_validateParty(this.Form.transactionTypeData.transactionParties);
				}

				this.Form.dynamicMenuItems = [];

				let self = this;
				if(this.Form.transactionTypeData && this.Form.transactionTypeData.transactionSections.length){
					this.Form.transactionTypeData.transactionSections.forEach(function (item) {
						let obj = {};
						obj.MenuID = null;
						obj.Icon = null;
						obj.Text = item.sectionName;
						obj.Action = 'section_'+item.sectionId;
						obj.sectionId = item.sectionId;
						obj.hideOption = false;
						self.Form.dynamicMenuItems.push(obj);
					});
				}

				//inserting eway bill details to transaction type fields manually
				this.fn_bindEwayBillSection();

				if(updateNS && this.Form.customFields.length){
					this.Form.dynamicMenuItems.length ? this.fn_bindCustomFieldValues() : this.Form.customFields = [];
				}
				/*this.Form.transactionTypeData.transactionSections.push(this.ewayBillDetailSection);

				!this.Form.transactionTypeData.transactionTypeFields.length ? this.Form.transactionTypeData.transactionTypeFields = [] : '';

				for(let i=0; i<this.ewayBillDetailFields.length; i++){
					this.Form.transactionTypeData.transactionTypeFields.push(this.ewayBillDetailFields[i]);
				}*/

				// callback != undefined ? callback(1) : '';
				if(callback != undefined){
					callback(1);
				}
				else{
					setTimeout(function(){
						self.$root.fn_copyFormObject(self.Form, self.formId);
					},500);
				}

				// this.hideLoading();
				this.loading = false;
			},

			fn_bindEwayBillSection: function(){
				this.Form.transactionTypeData.transactionSections.push(this.ewayBillDetailSection);

				!this.Form.transactionTypeData.transactionTypeFields.length ? this.Form.transactionTypeData.transactionTypeFields = [] : '';

				for(let i=0; i<this.ewayBillDetailFields.length; i++){
					this.Form.transactionTypeData.transactionTypeFields.push(this.ewayBillDetailFields[i]);
				}
			},

			fn_bindCustomFieldValues: function(){
				for(let i=0; i<this.Form.customFields.length; i++){

					// updating section key values on transaction type form change
					let customFieldItem = this.Form.customFields[i];
					customFieldItem.section.transactionTypeFormId = this.Form.transactionTypeData.transactionTypeFormId;
					for(let j=0; j<this.Form.transactionTypeData.transactionSections.length; j++){
						if(customFieldItem.section.sectionName == this.Form.transactionTypeData.transactionSections[j].sectionName){
							customFieldItem.section.sectionId = this.Form.transactionTypeData.transactionSections[j].sectionId;
						}
					}

					// updating section fields key values on transaction type form change
					for(let k=0; k<customFieldItem.items.length; k++){
						let fieldItem = customFieldItem.items[k];
						fieldItem.transactionTypeFormId = this.Form.transactionTypeData.transactionTypeFormId;
						for(let l=0; l<this.Form.transactionTypeData.transactionTypeFields.length; l++){

							if(fieldItem.fieldId == this.Form.transactionTypeData.transactionTypeFields[l].fieldId){
								fieldItem.sectionId = customFieldItem.section.sectionId;
								fieldItem.transactionTypeFieldId = this.Form.transactionTypeData.transactionTypeFields[l].transactionTypeFieldId;
							}
							
						}	
					}

					// hiding dynamic menu option if custom field exist on transaction type form change
					for(let m=0; m<this.Form.dynamicMenuItems.length; m++){
						if(customFieldItem.section.sectionId == this.Form.dynamicMenuItems[m].sectionId){
							this.Form.dynamicMenuItems[m].hideOption = true;
						}
					}
				}
				
			},

			// fn_bindTransactionNumber: function () {

			// 	this.transactionNumberSnackbar = false;

			// 	let numberSeriesData = this.Form.transactionTypeData.numberSeries;

			// 	this.Form.transactionData.prefix = numberSeriesData.prefix;
			// 	this.Form.transactionData.suffix = numberSeriesData.suffix;

			// 	//For reference use only as incrementing transaction number by numberSeries id in transaction number
			// 	this.Form.transactionData.numberSeriesId = numberSeriesData.numberSeriesId;

			// 	this.Form.transactionData.transactionNumberId = numberSeriesData.transactionNumberId

			// 	let self = this;

			// 	// this.getData('TransactionNumber', numberSeriesData.numberSeriesId, 
			// 	this.getData('TransactionNumber', numberSeriesData.transactionNumberId, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				let data = JSON.parse(response);
			// 				self.Form.transactionData.transactionNumber = Number(data.transactionNumber);
			// 				self.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
			// 	        }, 
			// 	        onError: function(error){
			// 	          	console.log(error);
			// 	        }
			// 		}
		 //        );
				
			// },

			fn_bindTransactionNumber: function () {

				if(!this.Form.transactionTypeData){
					return;
				}

				this.transactionNumberSnackbar = false;

				let numberSeriesData = this.Form.transactionTypeData.numberSeries;

				// this.Form.transactionData.prefix = numberSeriesData.prefix;
				// if(this.$refs['ref_dialogNumberSeries'] && this.$refs['ref_dialogNumberSeries'].prefix){
				// 	this.Form.transactionData.prefix = this.$refs['ref_dialogNumberSeries'].prefix;
				// }
				// else{
				// 	this.Form.transactionData.prefix = numberSeriesData.otherPrefix ? numberSeriesData.otherPrefix : numberSeriesData.prefix;
				// 	this.Form.transactionData.suffix = numberSeriesData.suffix;
				// }

				this.Form.transactionData.prefix = numberSeriesData.otherPrefix !== null ? numberSeriesData.otherPrefix : numberSeriesData.prefix;
				this.Form.transactionData.suffix = numberSeriesData.suffix;

				//For reference use only as incrementing transaction number by numberSeries id in transaction number
				this.Form.transactionData.numberSeriesId = numberSeriesData.numberSeriesId;

				// this.Form.transactionData.transactionNumberId = numberSeriesData.transactionNumberId;

				let filterObject = {};
				filterObject.numberSeriesId = numberSeriesData.numberSeriesId;
				// filterObject.transactionNumberId = numberSeriesData.transactionNumberId;
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));

				filterObject.typeId = this.settings.transactionTypeId;

				let self = this;

				this.getFilterData('TransactionNumber', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							self.Form.transactionData.transactionNumber = Number(data.transactionNumber);
							self.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
							self.Form.transactionData.transactionNumberId = data.transactionNumberId;
							if(self.$root.appVersion >= 136){
								self.Form.transactionData.prefix = data.otherPrefix !== null ? data.otherPrefix : data.prefix;
							}
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
				
			},

			// fn_bindTransactionTypeAddOns: function (bindAll, callback) {
			fn_bindTransactionTypeAddOns: function (bindAll) {
				let self = this;
				let tempAddOns = null;

				if(bindAll){
					this.Form.productDataModel.addOnsItems = [];
					// !dont remove as will be useful if transaction form open for user
					// this.Form.transactionAddOns = [];
				}

				this.Form.transactionTypeData.transactionTypeAddOns.forEach(function (item) {

					if(item.type==0){

						if(bindAll){
							self.Form.items.forEach(function (itemData) {

								itemData.addOnsItems.push(JSON.parse(JSON.stringify(item)));

								(function (itemData) {
									itemData.netAmount = self.$refs['ref_dialogProduct'].fn_computeValues(itemData);
								}(itemData));

							});
						}

	          			self.Form.productDataModel.addOnsItems.push(JSON.parse(JSON.stringify(item)));
					}
					else if(item.type==1 && bindAll){
						let addOnsData = JSON.parse(JSON.stringify(item));
						addOnsData.transactionAddOnsId = self.guid();
						addOnsData.isDefault = true;
						self.Form.transactionAddOns.push(addOnsData);
					}
	          	});

				// callback != undefined ? callback(1) : '';
			},

			fn_validateParty: function (partyGroups) {
				let filterObject = {};
				filterObject.accountGroups = [];

				let partyId = null;

				if(partyGroups){
					partyGroups.forEach(function (item) {
						filterObject.accountGroups.push(item.accountGroupId);
					});
					partyId = this.Form.partyId;
				}
				else{
					filterObject.accountGroups = [accountGroupIds.indirectExpense.id, accountGroupIds.directExpense.id, accountGroupIds.fixedAssets.id];
					partyId = this.Form.expenseData.accountLedgerId;
				}
				

				let self = this;
				this.getFilterData('ValidateParty', partyId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							self.isPartyValid = JSON.parse(response);
							if(!self.isPartyValid){
								if(partyGroups){
									self.Form.partyId = null;
									self.Form.partyName = null;
									self.Form.placeOfSupplyId = null;
									self.Form.placeOfSupplyName = null;
									self.Form.placeOfSupplyCountryId = null;
									self.Form.placeOfSupplyCountryName = null;
									self.Form.partyDetails = null;
									self.showToast("Ledger created is not a Supplier");
								}
								else{
									self.Form.expenseData.accountLedgerId = null;
		        					self.Form.expenseData.accountLedgerName = null;
		        					self.showToast("Ledger doesn't belong to expense group");
								}
								
							}
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getBottomMenu: function (tagId) {

				let menuItems = [menuItem.save, menuItem.reset, menuItem.applyTds];

				// !this.Form.isNew ? menuItems.unshift(menuItem.cancelTransaction) : '';

				// this.Form.dynamicMenuItems.forEach(function (item) {
				// 	menuItems.push(item);
				// });

				var bottomMenu = {"BottomMenu": menuItems};

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			// fn_getBottomMenuAddOns: function () {

			// 	var bottomMenu = {"BottomMenu": [menuItem.addDiscount, menuItem.addTaxes, menuItem.addOtherCharges]};

			// 	this.setBottomMenu(null, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_getBottomMenuAttachment: function () {

				if(!this.$root.CurrentBusiness.DataDrive && this.transactionCount>=3){
	                // this.showToast("Set up backup drive to attach documents");
					this.fn_openDialogDriveSetup();
	                return;
	            }

				if(this.Form.attachments.length === 5){
					this.showToast("Maximum 5 attachments are allowed.");
					return;
				}

				var bottomMenu = {"BottomMenu": [menuItem.camera, menuItem.fileManager]};

				this.setBottomMenu(null, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_closeDialog: function (tagId) {
				// if(this.$refs['ref_dialogPermission'].dialog_permission){
				// 	this.$refs['ref_dialogPermission'].dialog_permission = false;
				// 	return;
				// }
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_calculateTax: function (updateTaxMode) {
				let self = this;
				// this.Form.taxMode == 0 ? this.Form.isRcmApplicable = false : '';
				if(this.Form.taxMode == 0){
					this.Form.isRcmApplicable = false;
					this.Form.isItcEligible = false;
					this.fn_itcEligible(false);
				}

				this.Form.items.forEach(function (item) {

					if(self.Form.taxMode && updateTaxMode){
						!item.taxValue ? item.taxValue = item.defaultTaxValue : '';
						//isCessApplicable is coming by using taxCategoryId saved in transactionProducts and using only to check cess is applicable or not at master level
						// Rest all default keys are coming from taxCategory table via productId saved in transactionProducts

						// !item.cessValue && item.isCessApplicable ? item.cessValue = item.defaultCessValue : '';
						if(item.isCessApplicable){
							!item.cessValue && !item.cessAmount ? item.cessValue = item.defaultCessValue : '';
						}
						

						if(!item.taxCategoryId){
							item.taxCategoryId = item.defaultTaxCategoryId;
							item.taxCategoryName = item.defaultTaxCategoryName;
						}

						// item.addOnsItems.forEach(function (addOnsItem) {
						// 	addOnsItem.hsnCode = item.defaultHsnCode;
						// });
						item.hsnCode = item.defaultHsnCode;
					}

					(function (item) {
						item.netAmount = self.$refs['ref_dialogProduct'].fn_computeValues(item);
					}(item))
				});
			},

			fn_checkValidations: function(){
				this.disableSaveBtn = true;
				this.showLoading('Please wait...');
				var self = this;
			    this.$validator.validateAll().then((result) => {
			        if (result) {

			    //     	if(this.Form.inventory && !this.Form.items.length){
							// this.showToast("Please add items");
							// this.disableSaveBtn = false;
			    //     		this.hideLoading();
			    //     		return;
			    //     	}

			        	if(this.roundedAmount <= 0){
							this.showToast("Bill amount can't be zero or less then zero");
							this.disableSaveBtn = false;
			        		this.hideLoading();
			        		return;
			        	}

			        	if(this.splitPaymentTotal != this.roundedAmount){
			        		this.hideLoading();
							this.showToast("Please adjust payment as per invoice total");
							this.disableSaveBtn = false;
			        		this.fn_openDialog_PaymentOptions();
			        		return
			        	}



			        	this.fn_checkTransactionNumber(function(){
			        		self.fn_post();
			        	});

			           // 	self.fn_post();
			          	// return; 

			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        	this.hideLoading();
			        	this.disableSaveBtn = false;
			        }
			    });
			},

			fn_checkTransactionNumber: function(callback){
				var self = this;
				let filterObject = {};
				filterObject.mergeTransactionNumber = this.Form.transactionData.mergeTransactionNumber;
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
				filterObject.typeId = this.settings.transactionTypeId;
				let transactionId = this.Form.transactionData.transactionId ? this.Form.transactionData.transactionId : null;
				this.getFilterData('CheckTransactionNumber', transactionId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							callback ? callback() : '';
				        }, 
				        onError: function(error){
							self.disableBtn = false;
							self.disableSaveBtn = false;
				          	console.log(error);
				          	self.showToast('Transaction number already exists');
				          	self.hideLoading();
				          	self.transactionNumberSnackbar = true;
				        }
					}
		        );
			},

			fn_saveLocal: function(dataObj){
				this.backButtonPress = false;
				var self = this;
				this.postData('Expense', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          self.fn_cleanUp();
				        },
				        onError: function(error){
				        	self.hideLoading();
							self.disableBtn = false;
							self.disableSaveBtn = false;
				          	console.log(error);
				        }
					}
		        );
			},

			fn_cleanUp: function () {
				// this.loadedFromDraft = false;
				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){

					if(localStorage.getItem("transaction_items_state")){
						let obj = JSON.parse(localStorage.getItem("transaction_items_state"));
						obj.itemId = self.Form.transactionData.transactionId;
						localStorage.setItem("transaction_items_state",JSON.stringify(obj));
					}

					// posting metrics on save
					let postObj = {"eventName":self.toolbarTitle.toLowerCase() + '_save',"eventData":[{"eventKey":"transaction_number","eventValue":self.Form.transactionData.mergeTransactionNumber}]}
        			
					let saveObj = {};
					saveObj.eventKey = "transaction_save";
					saveObj.eventValue = self.Form.transactionData.mergeTransactionNumber;
					postObj.eventData.push(saveObj);
					
					self.$root.fn_postMetrics(postObj);

					self.hideLoading();
					self.fn_previewInvoice(false, 'purchase');

					// if(self.Form.inventory){
					// 	self.fn_previewInvoice(false, 'purchase');
					// }
					// else{
					// 	self.fn_previewInvoice(false, 'purchase', 'ab');
					// }
				});;
			},

			fn_post: function(){

				if(this.$root.CurrentBusiness.GSTRegistrationStatus != 1 || this.Form.taxMode == 0){
					this.Form.isItcEligible = false;
				}

				let addOnsTotal = 0;
				// let expenseLedgerAmount = this.Form.inventory ? this.Form.itemsSummary.grossAmount: this.Form.expenseData.amount;
				let expenseLedgerAmount = null;
				if(this.Form.items.length){
					expenseLedgerAmount = this.Form.itemsSummary.grossAmount;
				}
				else{
					expenseLedgerAmount = this.Form.expenseData.amount;
				}

				// let totalGst = 0;
				let totalDiscount = 0;
				let totalTax = 0;
				let totalOtherCharges = 0;

				//only in case of new transaction
				if(!this.Form.transactionData.transactionId){
					this.Form.transactionData.transactionId = this.guid();
					// this.Form.transactionData.createdDate = new Date();
					this.Form.transactionData.createdDate = this.$root.fn_getLocalDateFormat();
				}

				this.Form.transactionData.partyId = this.Form.partyId;
				this.Form.transactionData.grossAmount = this.Form.itemsSummary.grossAmount;
				this.Form.transactionData.netAmount = this.netAmount;
				this.Form.transactionData.amount = this.totalAmount;
				this.Form.transactionData.roundedAmount = this.roundedAmount//Math.round(this.totalAmount);
				this.Form.transactionData.taxMode = this.Form.taxMode;
				this.Form.transactionData.transactionTypeFormId = this.Form.transactionTypeFormId;
				// this.Form.transactionData.modifiedDate = new Date();
				this.Form.transactionData.createdDate = this.$root.fn_getLocalDateFormat();
				// this.Form.transactionData.invoiceType = this.Form.invoiceType;

				this.Form.transactionData.placeOfSupplyId = null;

				// if(this.$root.CurrentBusiness.GSTRegistrationStatus==1){
		        // 	this.Form.transactionData.placeOfSupplyId = this.Form.placeOfSupplyId;
		        // 	this.Form.transactionData.placeOfSupplyCountryId = this.Form.placeOfSupplyCountryId;
		        // }
				this.Form.transactionData.placeOfSupplyId = this.Form.placeOfSupplyId;
		        this.Form.transactionData.placeOfSupplyCountryId = this.Form.placeOfSupplyCountryId;

		        if(this.Form.transactionData.paymentMode!=null){
					this.Form.transactionData.splitPayment = this.Form.splitPayment;
				}

		        this.Form.transactionData.isRounded = this.Form.isRounded;
		        this.Form.transactionData.roundOffValue = this.Form.roundOffValue;
		        this.Form.transactionData.isRcmApplicable = this.Form.isRcmApplicable ? 1 : 0;
				this.Form.transactionData.documentDetails = this.Form.attachments;
				this.Form.transactionData.isCashTransaction = this.Form.isCashTransaction;
				this.Form.transactionData.isItcEligible = this.Form.isItcEligible;
				
				if(!this.Form.items.length){
					this.Form.transactionData.description = this.Form.description;
				}
				else{
					this.Form.transactionData.description = null;
				}

				this.Form.transactionData.expenseCategoryId = this.Form.expenseCategoryId;

				this.Form.transactionData.paymentTerm = this.Form.selectedPaymentTerm ? this.Form.selectedPaymentTerm : this.Form.paymentTerm;

				// this.Form.transactionData.prefix = this.Form.transactionData.prefix ? this.Form.transactionData.prefix : null;
				this.Form.transactionData.suffix = this.Form.transactionData.suffix ? this.Form.transactionData.suffix : null;

				let postObj = {};
				postObj = JSON.parse(JSON.stringify(this.Form.transactionData));

				postObj.transactionSections = [];
				postObj.transactionFields = [];
				postObj.transactionProducts = [];
				postObj.transactionProductAddOns = [];
				postObj.transactionAddOns = [];
				postObj.transactionTds = [];
				postObj.ledgerAccounts = [];
				postObj.transactionLedgers = [];

				let self = this;

				//Inserting 
					// dynamic/custom section to transactionSections
					// dynamic/custom fields to transactionFields
				if(this.Form.customFields.length){

					this.Form.customFields.forEach(function (item, index) {

						let sectionObj = {};
						sectionObj.transactionSectionId = self.guid()
						sectionObj.sectionId = item.section.sectionId;
						sectionObj.sectionName = item.section.sectionName;
						// sectionObj.orderNumber = index+1;
						sectionObj.orderNumber = item.section.orderNumber;

						postObj.transactionSections.push(sectionObj);

						item.items.forEach(function (fieldItem, index) {

							let fieldObj = {};
							fieldObj.transactionFieldId	= self.guid();
							fieldObj.transactionSectionId = sectionObj.transactionSectionId;
							fieldObj.transactionTypeFieldId = fieldItem.transactionTypeFieldId;
							fieldObj.sectionId = item.section.sectionId;
							fieldObj.orderNumber = index+1;
							fieldObj.fieldId = fieldItem.fieldId;
							fieldObj.fieldName = fieldItem.displayName;
							fieldObj.fieldValue = fieldItem.value;
							fieldObj.fieldDataType = fieldItem.fieldType;

							fieldObj.accountLedgerId = fieldItem.accountLedgerId ? fieldItem.accountLedgerId : null;
							fieldObj.listItemId = fieldItem.listItemId ? fieldItem.listItemId : null;

							postObj.transactionFields.push(fieldObj);
						})
					})

				}

				//Expense ledger entry
				let ledgerObj = {};
				ledgerObj.transactionLedgerId = this.guid();
				ledgerObj.accountLedgerId = this.Form.expenseData.accountLedgerId;
				// ledgerObj.amount = this.Form.expenseData.amount;
				ledgerObj.amount = this.roundedAmount;
				ledgerObj.amountType = 1;
				ledgerObj.orderNumber = 1;
				ledgerObj.transactionListId = self.Form.transactionData.transactionListId;
				postObj.transactionLedgers.push(ledgerObj);

				//Inserting 
					// products/items to transactionProducts 
					// product's addOns to transactionProductAddOns

				if(this.Form.items.length){

					this.Form.items.forEach(function(item){

						item.groupId = self.guid();

						//Transaction Products Entries
						item.productVariants.forEach(function (vItem) {

							let tpObj = {};

							tpObj.transactionLedgerId = ledgerObj.transactionLedgerId;

							if(vItem.qty){

								!vItem.transactionProductId ? tpObj.transactionProductId = self.guid() : tpObj.transactionProductId = vItem.transactionProductId;

								tpObj.productId = vItem.productId;

								tpObj.productVariantId = vItem.productVariantId;

								tpObj.groupId = item.groupId;

								tpObj.mrp = item.mrp ? item.mrp : 0;

								tpObj.rate = item.rate ? item.rate : 0;

								tpObj.description = item.description;

								tpObj.additionalData = null;

								tpObj.unitId = vItem.unitId;

								tpObj.primaryUnitId = vItem.primaryUnitId;

								tpObj.qty = vItem.qty;

								tpObj.packQuantity = vItem.packQuantity ? vItem.packQuantity : 1;

								tpObj.transactionProductMode = 1;

								if(self.settings.transactionTypeId == transactionTypes.purchaseReturn.id){
									tpObj.actualQty = -vItem.qty;
								}
								else{
									tpObj.actualQty = vItem.qty;
								}

								tpObj.netAmount = item.netAmount;
								tpObj.taxableValue = item.taxableValue;

								let packQty = vItem.packQuantity ? vItem.packQuantity : 1;

								let amount = item.rate * vItem.qty * packQty;
								tpObj.amount = self.roundUpto2Decimals(amount);


								tpObj.transactionListId = self.Form.transactionData.transactionListId;
								tpObj.stockInventory = false;

								tpObj.refTId = null;
								tpObj.refTpId = null;

								//saving tax category id in transaction products in case of tax mode exclusive/inclusive
								tpObj.taxCategoryId = item.taxCategoryId;

								tpObj.hsnCode = item.hsnCode;

								if(!self.Form.taxMode){
									tpObj.taxCategoryId = item.defaultTaxCategoryId ? item.defaultTaxCategoryId : '';
								}

								tpObj.orderNumber = postObj.transactionProducts.length + 1;

								postObj.transactionProducts.push(tpObj);

							}

						})

						if(item.addOnsItems && item.addOnsItems.length){

							item.addOnsItems.forEach(function (addOnsItem, index) {

								let addOnsObj = {};

								if(addOnsItem.value!==null && addOnsItem.value!==''){

									if(!addOnsItem.isGst){

										addOnsItem.addOnsType == 1 ? totalDiscount += addOnsItem.value : addOnsItem.addOnsType == 2 ? totalTax += addOnsItem.value : totalOtherCharges += addOnsItem.value;

										addOnsObj.transactionProductsAddOnsId = self.guid();
										addOnsObj.transactionProductGroupId = item.groupId;
										addOnsObj.orderNumber = index+1;
										addOnsObj.addOnsId = addOnsItem.addOnsId;

										//saving name, nature and mode for display purpose only
										addOnsObj.addOnsName = addOnsItem.name;
										addOnsObj.addOnsNature = addOnsItem.nature;
										addOnsObj.addOnsMode = addOnsItem.mode;

										addOnsObj.addOnsType = addOnsItem.addOnsType;
										addOnsObj.percentage = addOnsItem.percentage;
										addOnsObj.value = addOnsItem.value;
										addOnsObj.isGst = null;

										// sending taxable value to transaction product addons as per puran request
										addOnsObj.fullTaxableValue = item.taxableValue;
										// addOnsObj.hsnCode = item.hsnCode ? item.hsnCode : null;

										postObj.transactionProductAddOns.push(addOnsObj);

										//Passing ledger entry if purchase account selected

										let ledgerObj = {};

										if(addOnsItem.nature){
											ledgerObj.amountType = 0;//Credit
											ledgerObj.amount = -addOnsItem.value;
										}
										else{
											ledgerObj.amountType = 1;//Debit
											ledgerObj.amount = addOnsItem.value;
										}

										if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry){
											ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
											let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
											postObj.ledgerAccounts.push(data);
										} 
										else{

											if(addOnsItem.nature){
												expenseLedgerAmount -= addOnsItem.value;
											}
											else{
												expenseLedgerAmount += addOnsItem.value;
											}

										}

									}
									
								}
							});
						}

						// adding tax as addons

						self.Form.gstAddOns.forEach(function (addOnsItem, index) {
							

							let tpAddOnsId = self.fn_getSavedGstAddOns(item.groupId, addOnsItem.addOnsId);

							if(self.Form.taxMode){

								let addOnsObj = {};

								!tpAddOnsId ? addOnsObj.transactionProductsAddOnsId = self.guid() : addOnsObj.transactionProductsAddOnsId = tpAddOnsId;

								addOnsObj.transactionId = self.Form.transactionData.transactionId;
								addOnsObj.transactionProductGroupId = item.groupId;
								addOnsObj.orderNumber = postObj.transactionProductAddOns.length+1;
								addOnsObj.addOnsId = addOnsItem.addOnsId;

								//saving name, nature and mode for display purpose only
								addOnsObj.addOnsName = addOnsItem.name;
								addOnsObj.addOnsNature = addOnsItem.nature;
								addOnsObj.addOnsMode = addOnsItem.mode;

								addOnsObj.addOnsType = 2;

								// let taxpercent = item.taxValue / self.Form.gstAddOns.length;
								// addOnsObj.percentage = self.roundUpto2Decimals(taxpercent);//addOnsItem.percentage;
								addOnsObj.percentage = item.taxValue / self.Form.gstAddOns.length;//addOnsItem.percentage;

								// let taxvalue = item.taxAmount / self.Form.gstAddOns.length;
								// addOnsObj.value = self.roundUpto2Decimals(taxvalue);//addOnsItem.value;
								addOnsObj.value = item.taxAmount / self.Form.gstAddOns.length;//addOnsItem.value;

								addOnsObj.isGst = 1;
								// addOnsObj.hsnCode = item.hsnCode;

								postObj.transactionProductAddOns.push(addOnsObj);

								totalTax += addOnsObj.value;
								// totalGst += addOnsObj.value;

								//Passing ledger entry if purchase account selected

								// if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && self.$root.CurrentBusiness.GSTRegistrationStatus == 1){

								// 	let ledgerObj = {};
								// 	addOnsTotal += addOnsObj.value;
								// 	ledgerObj.amountType = 1//debit;

								// 	if(self.Form.isRcmApplicable){
								// 		ledgerObj.accountId = addOnsItem.saleAccountItemId;

								// 		// Rcm input tax entry
								// 		let ledgerObjRcm = {};
								// 		ledgerObjRcm.amountType = 0//credit;
								// 		ledgerObjRcm.accountId = addOnsItem.purchaseAccountItemId;
								// 		ledgerObjRcm.amount = -addOnsObj.value;
								// 		let rcmData = self.fn_bindAndReturnSimilarValues(ledgerObjRcm);
								// 		postObj.ledgerAccounts.push(rcmData);
								// 	}
								// 	else{
								// 		ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
								// 	}
								// 	ledgerObj.amount = addOnsObj.value;
								// 	let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
								// 	postObj.ledgerAccounts.push(data);
								// }

								// if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && self.$root.CurrentBusiness.GSTRegistrationStatus == 1){
								if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && self.$root.CurrentBusiness.GSTRegistrationStatus != 3){

									addOnsTotal += addOnsObj.value;

									if(self.Form.isRcmApplicable && !self.Form.isItcEligible){
										// in case of rcm applicable
										let ledgerObj = {};
										ledgerObj.amountType = 0;
										ledgerObj.amount = -addOnsObj.value;
										ledgerObj.accountId = addOnsItem.saleAccountItemId;
										let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
										postObj.ledgerAccounts.push(ledgerObj);
									}

									//will only applicable in case of registered business as isItcEligible will be false in business type 2 and 3
									if(self.Form.isItcEligible && !self.Form.isRcmApplicable){
										// in case of itc eligible
										let ledgerObj = {};
										ledgerObj.amountType = 1;
										ledgerObj.amount = addOnsObj.value;
										ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
										let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
										postObj.ledgerAccounts.push(ledgerObj);
									}
								}

							}
						});

						//adding cess as addons
						if(item.isCessApplicable && self.Form.taxMode){

							let addOnsItem = self.Form.cessAddOns;

							let tpAddOnsId = self.fn_getSavedGstAddOns(item.groupId, addOnsItem.addOnsId);

							let addOnsObj = {};

							!tpAddOnsId ? addOnsObj.transactionProductsAddOnsId = self.guid() : addOnsObj.transactionProductsAddOnsId = tpAddOnsId;

							addOnsObj.transactionId = self.Form.transactionData.transactionId;
							addOnsObj.transactionProductGroupId = item.groupId;
							addOnsObj.orderNumber = postObj.transactionProductAddOns.length+1;
							addOnsObj.addOnsId = addOnsItem.addOnsId;

							//saving name, nature and mode for display purpose only
							addOnsObj.addOnsName = addOnsItem.name;
							addOnsObj.addOnsNature = addOnsItem.nature;
							addOnsObj.addOnsMode = addOnsItem.mode;

							addOnsObj.addOnsType = 2;

							// addOnsObj.percentage = self.roundUpto2Decimals(item.cessValue);//addOnsItem.percentage;
							addOnsObj.percentage = item.cessValue!=null ? self.roundUpto2Decimals(item.cessValue) : null;

							addOnsObj.value = self.roundUpto2Decimals(item.cessAmount);//addOnsItem.value;

							addOnsObj.isGst = 2;
							// addOnsObj.hsnCode = item.hsnCode;

							postObj.transactionProductAddOns.push(addOnsObj);

							totalTax += addOnsObj.value != null ? addOnsObj.value : 0;
							// totalGst += addOnsObj.value != null ? addOnsObj.value : 0;

							//Passing ledger entry if purchase account selected

							// if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && self.$root.CurrentBusiness.GSTRegistrationStatus == 1){
							if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && self.$root.CurrentBusiness.GSTRegistrationStatus != 3){

								addOnsTotal += addOnsObj.value;

								if(self.Form.isRcmApplicable && !self.Form.isItcEligible){
									// in case of rcm applicable
									let ledgerObj = {};
									ledgerObj.amountType = 0;
									ledgerObj.amount = -addOnsObj.value;
									ledgerObj.accountId = addOnsItem.saleAccountItemId;
									let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
									postObj.ledgerAccounts.push(ledgerObj);
								}

								if(self.Form.isItcEligible && !self.Form.isRcmApplicable){
									// in case of itc eligible
									let ledgerObj = {};
									ledgerObj.amountType = 1;
									ledgerObj.amount = addOnsObj.value;
									ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
									let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
									postObj.ledgerAccounts.push(ledgerObj);
								}

								// let ledgerObj = {};
								// addOnsTotal += addOnsObj.value;
								// ledgerObj.amountType = 1//debit;
								// ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
								// ledgerObj.amount = addOnsObj.value;
								// let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
								// postObj.ledgerAccounts.push(data);
							}

						}
					})

				}

				//Inserting
					// transaction's addOns to transactionAddOns
				if(this.Form.transactionAddOns.length){

					this.Form.transactionAddOns.forEach(function (addOnsItem, index) {
						
						let addOnsObj = {};

						if(addOnsItem.value!==null && addOnsItem.value!==''){

							addOnsItem.addOnsType == 1 ? totalDiscount += addOnsItem.value : addOnsItem.addOnsType == 2 ? totalTax += addOnsItem.value : totalOtherCharges += addOnsItem.value;

							addOnsObj.transactionAddOnsId = addOnsItem.transactionAddOnsId;
							addOnsObj.orderNumber = index+1;
							addOnsObj.addOnsId = addOnsItem.addOnsId;

							//saving name, nature and mode for display purpose only
							addOnsObj.addOnsName = addOnsItem.name;
							addOnsObj.addOnsNature = addOnsItem.nature;
							addOnsObj.addOnsMode = addOnsItem.mode;

							addOnsObj.addOnsType = addOnsItem.addOnsType;
							addOnsObj.percentage = addOnsItem.percentage;
							addOnsObj.value = addOnsItem.value;
							addOnsObj.appliedOn = addOnsItem.appliedOn;
							addOnsObj.adjustInTotal = addOnsItem.adjustInTotal;

							addOnsObj.isDefault = addOnsItem.isDefault;

							if(addOnsItem.addOnsType==2 && (addOnsItem.addOnsId == fixedGstAddOns.CGST.id || addOnsItem.addOnsId == fixedGstAddOns.SGST.id || addOnsItem.addOnsId == fixedGstAddOns.UTGST.id || addOnsItem.addOnsId == fixedGstAddOns.IGST.id)){
								addOnsObj.isGst = 1;
							}

							addOnsItem.addOnsId == fixedCessAddOns.CESS.id ? addOnsObj.isGst = 2 : '';

							// sending taxable value to transaction addons as per puran request
							addOnsObj.fullTaxableValue = self.Form.transactionData.taxableValue;

							postObj.transactionAddOns.push(addOnsObj);

							//Passing ledger entry if purchase account selected

							// let ledgerObj = {};

							// if(addOnsItem.nature){
							// 	ledgerObj.amountType = 0;//credit
							// 	ledgerObj.amount = -addOnsItem.value;
							// }
							// else{
							// 	ledgerObj.amountType = 1;//debit
							// 	ledgerObj.amount = addOnsItem.value;
							// }

							let isTaxLedger = false;
							if(fixedGstAddOns.CGST.id == addOnsItem.addOnsId || fixedGstAddOns.SGST.id == addOnsItem.addOnsId || fixedGstAddOns.UTGST.id == addOnsItem.addOnsId || fixedGstAddOns.IGST.id == addOnsItem.addOnsId || fixedCessAddOns.CESS.id == addOnsItem.addOnsId){
								isTaxLedger = true;
							}

							// if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && self.$root.CurrentBusiness.GSTRegistrationStatus == 1){
							// if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && self.$root.CurrentBusiness.GSTRegistrationStatus != 3){
							if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry){
								

								// if(self.Form.isRcmApplicable && !self.Form.isItcEligible){
								// 	// in case of rcm applicable
								// 	let ledgerObj = {};
								// 	ledgerObj.amountType = 0;
								// 	ledgerObj.amount = -addOnsObj.value;
								// 	ledgerObj.accountId = addOnsItem.saleAccountItemId;
								// 	let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
								// 	postObj.ledgerAccounts.push(ledgerObj);
								// }

								// if(self.Form.isItcEligible && !self.Form.isRcmApplicable){
								// 	// in case of itc eligible
								// 	let ledgerObj = {};
								// 	ledgerObj.amountType = 1;
								// 	ledgerObj.amount = addOnsObj.value;
								// 	ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
								// 	let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
								// 	postObj.ledgerAccounts.push(ledgerObj);
								// }

								if(self.$root.CurrentBusiness.GSTRegistrationStatus==1 && !self.Form.isRcmApplicable){
									let ledgerObj = {};

									if(addOnsItem.nature){
										ledgerObj.amountType = 0;//credit
										ledgerObj.amount = -addOnsItem.value;
									}
									else{
										ledgerObj.amountType = 1;//debit
										ledgerObj.amount = addOnsItem.value;
									}

									ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
									let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
									postObj.ledgerAccounts.push(data);
								}
								else{
									if(!isTaxLedger){
										let ledgerObj = {};

										// ledgerObj.amountType = 0;//credit
										// ledgerObj.amount = -addOnsItem.value;
										if(addOnsItem.nature){
											ledgerObj.amountType = 0;//credit
											ledgerObj.amount = -addOnsItem.value;
										}
										else{
											ledgerObj.amountType = 1;//debit
											ledgerObj.amount = addOnsItem.value;
										}

										ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
										let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
										postObj.ledgerAccounts.push(data);
									}
								}

							}
							else{

								if(addOnsItem.nature){
									expenseLedgerAmount -= addOnsItem.value;
								}
								else{
									expenseLedgerAmount += addOnsItem.value;
								}

							}
						}

					})
				}

				//Inserting
					// transaction's tds to transactionTdsId
				if(this.Form.tdsDetails.transactionTdsId){

					postObj.transactionTds.push(this.Form.tdsDetails);

					//Passing ledger entry if purchase account selected
					if(this.passLedgerEntry){
						let ledgerObj = {};

						ledgerObj.amountType = 0//credit;
						ledgerObj.accountId = this.Form.tdsDetails.tdsAccountId;
						ledgerObj.amount = -this.Form.tdsDetails.amount;
						let data = this.fn_bindAndReturnSimilarValues(ledgerObj);
						postObj.ledgerAccounts.push(data);
					}
				}

				
				if(this.passLedgerEntry){
					//Inserting
						// transaction's type entry ledgers to ledger accounts

					let purchaseLedgerObj = {};
					purchaseLedgerObj.amountType = 1;//debit

					// if(this.Form.gstType=='IntraState' || this.Form.gstType=='UnionTerritory')
					// 	if(this.Form.transactionTypeData.transactionNature == 1)
					// 		purchaseLedgerObj.accountId = this.Form.transactionTypeData.importExportTransactionAccountId;
					// 	else
					// 		purchaseLedgerObj.accountId = this.Form.transactionTypeData.localTransactionAccountId;
					// else{
					// 	if(this.Form.transactionTypeData.transactionNature == 1)
					// 		purchaseLedgerObj.accountId = this.Form.transactionTypeData.importExportTransactionAccountId;
					// 	else
					// 		purchaseLedgerObj.accountId = this.Form.transactionTypeData.centralTransactionAccountId;
					// }

					purchaseLedgerObj.accountId = this.Form.expenseData.accountLedgerId;

					// if(this.Form.taxMode==2){
					// 	purchaseLedgerObj.amount  = expenseLedgerAmount - this.roundUpto2Decimals(totalGst);
					// }
					// else{
					// 	purchaseLedgerObj.amount  = expenseLedgerAmount;
					// }

					// if(this.$root.CurrentBusiness.GSTRegistrationStatus==1){
					if(this.$root.CurrentBusiness.GSTRegistrationStatus!=2 || this.Form.isRcmApplicable || !this.Form.items.length){
						purchaseLedgerObj.amount  = this.roundUpto2Decimals(expenseLedgerAmount);
					}
					else{
						// purchaseLedgerObj.amount  = this.roundUpto2Decimals(expenseLedgerAmount + totalGst);
						purchaseLedgerObj.amount  = this.roundUpto2Decimals(expenseLedgerAmount + totalTax);
					}

					// true && 
					// if(this.$root.CurrentBusiness.GSTRegistrationStatus != 2 && (this.Form.isRcmApplicable && !this.Form.isItcEligible) || (!this.Form.isRcmApplicable && !this.Form.isItcEligible)){
					if(this.Form.items.length && this.$root.CurrentBusiness.GSTRegistrationStatus != 3 && ((!this.Form.isRcmApplicable && !this.Form.isItcEligible) || this.Form.isRcmApplicable && !this.Form.isItcEligible)){
						// purchaseLedgerObj.amount  = this.roundUpto2Decimals(expenseLedgerAmount + totalGst);
						purchaseLedgerObj.amount  = this.roundUpto2Decimals(expenseLedgerAmount + totalTax);
					}

					// purchaseLedgerObj.amount = this.roundUpto2Decimals(expenseLedgerAmount);

					let purchaseLedger = this.fn_bindAndReturnSimilarValues(purchaseLedgerObj);
					postObj.ledgerAccounts.push(purchaseLedger);

					//Inserting
						// party entry ledgers to ledger accounts

					// let partyLedgerObj = {};
					// partyLedgerObj.amountType = 0;//credit
					// partyLedgerObj.accountId = this.Form.partyId;
					// partyLedgerObj.amount = this.roundedAmount;
					// let partyLedger = this.fn_bindAndReturnSimilarValues(partyLedgerObj);
					// postObj.ledgerAccounts.push(partyLedger);

					if(!this.Form.transactionData.paymentMode){
						let partyLedgerObj = {};
						partyLedgerObj.amountType = 0;//credit
						partyLedgerObj.accountId = this.Form.partyId;
						partyLedgerObj.amount = -this.roundedAmount;
						let partyLedger = this.fn_bindAndReturnSimilarValues(partyLedgerObj);
						this.Form.partyId ? postObj.ledgerAccounts.push(partyLedger) : '';
					}
					else{
						this.fn_generatePaymentEntries(postObj.ledgerAccounts, postObj.transactionLedgers);
					}

					if(this.roundedAmount!=this.totalAmount){
						let roundOffAmount = this.roundUpto2Decimals(Math.abs(this.roundedAmount - this.totalAmount));
						let roundOffLedgerObj = {};
						roundOffLedgerObj.amountType = this.totalAmount > this.roundedAmount ?  0 : 1;//credit/debit
						roundOffLedgerObj.accountId = "9d58ac9d-bf1b-4093-919a-2d68849e6176"; //round off ledgeraccountid //static for now
						roundOffLedgerObj.amount = roundOffLedgerObj.amountType == 0 ? -roundOffAmount : roundOffAmount;
						// roundOffLedgerObj.amount = roundOffAmount
						let roundOffLedger = this.fn_bindAndReturnSimilarValues(roundOffLedgerObj);
						postObj.ledgerAccounts.push(roundOffLedger);
					}
				}

				//Swaping amountType from debit to credit and credit to debit in case of purchase return
				if(self.settings.transactionTypeId == transactionTypes.purchaseReturn.id){
					postObj.ledgerAccounts.forEach(function (item) {
						item.amount = -item.amount;
						item.amountType == 1 ? item.amountType = 0 : item.amountType = 1;
					});
				}

				postObj.discount = this.roundUpto2Decimals(totalDiscount);
				postObj.tax = this.roundUpto2Decimals(totalTax);
				postObj.otherCharges = this.roundUpto2Decimals(totalOtherCharges);

				postObj.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
				postObj.sortDate = this.$moment(this.Form.transactionData.transactionDate).format('YYYY-MM-DD');

				postObj.onCredit = this.onCreditValue;

				// adding tax in taxable value in case of unregister/composite business
				// if(this.$root.CurrentBusiness.GSTRegistrationStatus != 1){
				// 	postObj.taxableValue = this.roundedAmount;
				// }
				// postObj.godownId = this.Form.godownId;

				console.log(JSON.stringify(postObj));
				this.fn_saveLocal(postObj);
			},

			// fn_bindAndReturnSimilarValues: function (ledgerObj) {
			// 	ledgerObj.ledgerAccountId = this.guid();
			// 	ledgerObj.transactionListId = this.Form.transactionData.transactionListId;
			// 	ledgerObj.transactionDate = this.Form.transactionData.transactionDate;	
			// 	return ledgerObj;
			// },

			fn_get: function(itemId, copyData){
				var self = this;
				this.Form.isNew = false;
				this.getData('Expense', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);

							self.Form.savedItemData = JSON.parse(response);

							self.fn_bindData(data, copyData);
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			fn_bindData: function (data) {
				
				this.Form.transactionData.additionalData = data.additionalData ? JSON.parse(data.additionalData) : null;
				this.Form.transactionData.createdBy = data.createdBy;
				this.Form.transactionData.createdDate = data.createdDate;
				// this.Form.transactionData.currencyId = data.currencyId;
				this.Form.transactionData.notes = data.notes;
				this.Form.partyId = data.partyId;
				this.Form.partyName = data.partyName;

				// this.Form.placeOfSupplyId = data.placeOfSupplyId;
				// this.Form.placeOfSupplyName = data.placeOfSupplyName;
				this.Form.placeOfSupplyCountryId = data.placeOfSupplyCountryId;
				this.Form.placeOfSupplyCountryName = data.placeOfSupplyCountryName;

				// //getting party details
				data.partyId ? this.fn_getPartyDetails(data.partyId) : '';

				this.Form.transactionData.refDate = data.refDate;
				this.Form.transactionData.refNumber = data.refNumber;
				this.Form.transactionData.status = data.status;
				this.Form.taxMode = data.taxMode;

				this.Form.transactionData.transactionDate = data.transactionDate;
				this.Form.transactionData.transactionId = data.transactionId;
				this.Form.transactionData.prefix = data.prefix;
				this.Form.transactionData.transactionNumber = data.transactionNumber;
				this.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
				this.Form.transactionData.suffix = data.suffix;

				this.Form.transactionTypeFormId = data.transactionTypeFormId;
				this.Form.transactionTypeFormName = data.transactionTypeFormName;

				// this.Form.invoiceType = data.invoiceType;

				this.Form.expenseData.accountLedgerId = data.transactionLedgers[0].accountLedgerId;
				this.Form.expenseData.accountLedgerName = data.transactionLedgers[0].accountLedgerName;
				this.Form.expenseData.amount = data.transactionLedgers[0].amount;

				this.Form.transactionData.numberSeriesId = data.numberSeriesId;
				this.Form.transactionData.transactionNumberId = data.transactionNumberId;

				this.Form.isRounded = data.isRounded;
				this.Form.isRcmApplicable = data.isRcmApplicable == 1 ? true : false;
				this.Form.attachments = data.documentDetails ?  data.documentDetails : [];

				this.Form.splitPayment = data.splitPayment;

				this.Form.description = data.description;

				this.Form.expenseCategoryId = data.expenseCategoryId;
				this.Form.expenseCategoryName = data.expenseCategoryName;
				this.Form.isItcEligible = data.isItcEligible;

				this.Form.isCashTransaction = data.isCashTransaction;

				this.Form.paymentTerm = data.paymentTerm;
				// this.Form.selectedPaymentTerm = data.paymentTerm > 30 ? null : data.paymentTerm;
				this.Form.selectedPaymentTerm = data.paymentTerm ? data.paymentTerm : -1;

				// if(data.godownId && data.godownName){
				// 	this.Form.godownId = data.godownId;
				// 	this.Form.godownName = data.godownName;
				// }

				let self = this;

				this.fn_getTransactionTypeData(data.transactionTypeFormId, function (args) {

					// if(data.placeOfSupplyId){
					// 	self.fn_updateState(data.placeOfSupplyId, data.placeOfSupplyName, false);
					// }
					self.fn_updateState(data.placeOfSupplyId, data.placeOfSupplyName, false);

					//getting party details
					// let bindGstAddOns = self.$root.CurrentBusiness.GSTRegistrationStatus != 3 ? true : false;
					// data.partyId ? self.fn_getPartyDetails(data.partyId, bindGstAddOns) : '';

					// self.Form.isCashTransaction = data.isCashTransaction;

					self.Form.items = [];

					let obj = {};
					obj.transactionProducts = [];

					//removing items if inventory not applicable
					// !self.Form.inventory ? data.transactionProducts = [] : '';

					if(data.transactionProducts && data.transactionProducts.length){

						// sorting items as per order number
						data.transactionProducts.sort(function(a, b){
						  	return a.orderNumber - b.orderNumber;
						});

						data.transactionProducts.forEach(function (item) {
					
							let itemObj = {};
							itemObj.groupTypeId = item.groupTypeId;
							itemObj.groupId = item.groupId;
							itemObj.mrp = item.mrp;
							itemObj.rate = item.rate;
							itemObj.description = item.description;
							itemObj.productId = item.productId;
							itemObj.productName = item.productName;
							itemObj.taxValue = 0;
							itemObj.taxAmount = 0;
							itemObj.cessValue = 0;
							itemObj.cessAmount = 0;
							itemObj.addOnsItems = [];

							itemObj.baseTransactionListId = item.baseTransactionListId;
							itemObj.baseTransactionNumber = item.baseTransactionNumber;

							itemObj.hsnCode = item.hsnCode;

							//getting default tax values from product master
							
							itemObj.defaultTaxValue = item.defaultTaxValue;
							itemObj.defaultCessValue = item.defaultCessValue;
							itemObj.defaultHsnCode = item.defaultHsnCode;
							itemObj.defaultTaxCategoryId = item.defaultTaxCategoryId;
							itemObj.defaultTaxCategoryName = item.defaultTaxCategoryName;
							itemObj.isCessApplicable = item.isCessApplicable;

							itemObj.taxCategoryId = item.taxCategoryId;
							itemObj.taxCategoryName = item.taxCategoryName;

							itemObj.productVariants = JSON.parse(JSON.stringify(item.productVariants));

							let tValue = 0;
							let tAmount = 0;

							item.transactionProductAddOns.forEach(function (addOnsItem) {

								addOnsItem.mode == 1 ? addOnsItem.percentage = null : '';
								
								if(addOnsItem.isGst==1){
									// itemObj.taxValue += addOnsItem.percentage;
									// itemObj.taxAmount += addOnsItem.value;
									tValue += addOnsItem.percentage;
									tAmount += addOnsItem.value;
									// itemObj.hsnCode = addOnsItem.hsnCode;
								}
								else if(addOnsItem.isGst==2){
									itemObj.cessValue = addOnsItem.percentage != null ? addOnsItem.percentage : null;
									itemObj.cessAmount = addOnsItem.value;
									// itemObj.hsnCode = addOnsItem.hsnCode;
								}

							});

							itemObj.taxValue = self.roundUpto2Decimals(tValue);
							itemObj.taxAmount = self.roundUpto2Decimals(tAmount);
							self.$forceUpdate();

							//doing this as default addons configuration can be changed from transactionType
							self.Form.productDataModel.addOnsItems.forEach(function (defaultAddOns) {

								let addOns = null;

								let itemIndex = item.transactionProductAddOns.findIndex(item=>{
									return defaultAddOns.addOnsId == item.addOnsId;
								});

								if(itemIndex!=-1){
									addOns = JSON.parse(JSON.stringify(item.transactionProductAddOns[itemIndex]));
									addOns.appliedOn = defaultAddOns.appliedOn;
									addOns.adjustInTotal = defaultAddOns.adjustInTotal;
								}

								addOns ? itemObj.addOnsItems.push(addOns) : '';
								
							});

							self.Form.items.push(itemObj);

						});

					}
					
					self.Form.transactionAddOns = [];

					if(data.transactionAddOns && data.transactionAddOns.length){

						data.transactionAddOns.forEach(function (item) {

							item.mode == 1 ? item.percentage = null : '';

							let addOnsItem = JSON.parse(JSON.stringify(item));
							
							self.Form.transactionAddOns.push(addOnsItem);

						});

					}
					

					if(data.transactionTds && data.transactionTds.length){
						self.Form.tdsDetails = JSON.parse(JSON.stringify(data.transactionTds[0]));
					}


					if(data.customFields && data.customFields.length){
						data.customFields.forEach(function (item) {

							//manual eway bill insertion
							if(item.section.sectionId == self.ewayBillDetailSection.sectionId){
								item.items = [];
								self.ewayBillDetailFields.forEach(function (eWayField){
									item.items.push(eWayField);
								})	
							}

							let customFieldItems = [];

							for(let i=0; i<self.Form.transactionTypeData.transactionTypeFields.length; i++){

								let transactionTypeField = self.Form.transactionTypeData.transactionTypeFields[i];

								for(let j=0; j<item.items.length; j++){

									if(transactionTypeField.sectionId == item.section.sectionId && transactionTypeField.fieldId == item.items[j].fieldId){
										//assigning display name from transaction type settings in case updated or not
										// item.items[j].displayName = transactionTypeField.displayName;
										customFieldItems.push(item.items[j]);
										break;
									}
								}
							}

							item.items = JSON.parse(JSON.stringify(customFieldItems));

							item.items.forEach(function (fieldItem) {
								fieldItem.additionalData = JSON.parse(fieldItem.additionalData);

								//manual eway bill insertion
								for(let i=0; i<data.transactionFields.length; i++){
									if(data.transactionFields[i].fieldId == fieldItem.fieldId){
										fieldItem.value = data.transactionFields[i].fieldValue;
									}
								}
							});
						});

						self.Form.customFields = JSON.parse(JSON.stringify(data.customFields));
					}

					//appending payment modes if applicable
					if(self.Form.transactionTypeData.paymentMode == 1 && data.transactionLedgers && data.transactionLedgers.length){
						let tLedgers = data.transactionLedgers.filter(item=>{
							return item.orderNumber != 1;
						})
						if(self.Form.splitPayment){
							// let tLedgers = data.transactionLedgers.filter(item=>{
							// 	return item.orderNumber != 1;
							// })
							self.Form.paymentOptions = JSON.parse(JSON.stringify(tLedgers));
						}
						else{
							self.Form.paymentLedgerId = tLedgers[0].accountLedgerId;
						}
					}

					// hide/show dynamic menu options
					for(let i=0; i<self.Form.customFields.length; i++){
						for(let j=0; j<self.Form.dynamicMenuItems.length; j++){
							if(self.Form.customFields[i].section.sectionId == self.Form.dynamicMenuItems[j].sectionId){
								self.Form.dynamicMenuItems[j].hideOption = true;
								self.$forceUpdate();
							}
							else if(self.Form.customFields[i].section.sectionId == self.ewayBillDetailSection.sectionId){
								self.Form.hideEwayOption = true;
							}
						}
					}

					self.fn_calculateTax();

					setTimeout(function(){
						// assigning at the end as making roundOffValue null while calculating net amount;
						self.Form.roundOffValue = data.roundOffValue;
						self.$root.fn_copyFormObject(self.Form, self.formId);
					},500);

				});

			},

			fn_getSavedGstAddOns: function (groupId, gstAddOnsId) {
				if(!this.Form.isNew && this.Form.savedItemData && this.Form.savedItemData.transactionProducts){
					let productItem = this.Form.savedItemData.transactionProducts.find(item=>{
						return item.groupId == groupId;
					});

					if(productItem){
						let gstAddOnsItem = productItem.transactionProductAddOns.find(addOnsItem=>{
							return addOnsItem.addOnsId == gstAddOnsId && addOnsItem.isGst;
						});

						// if true function will break here and will return transactionProductsAddOnsId
						if(gstAddOnsItem && gstAddOnsItem.transactionProductsAddOnsId)
							return gstAddOnsItem.transactionProductsAddOnsId;
					}
				}
				
				return null;
			},

			fn_clearForm: function(){
				this.unwatch = true;
				this.Form = {
					"transactionData":JSON.parse(JSON.stringify(transactionData)),
					"partyId":null, "partyName":null,
					"taxMode":0,
					"transactionTypeFormId":null, "transactionTypeFormName":null,

					"items":[],

					"expenseData":{"accountLedgerId":null, "accountLedgerName":null, "amount":null, "items":[]},

					"productDataModel": {"groupId":null, "productId":null, "groupTypeId":null, "productName":null, "mrp":null, "rate":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "taxCategoryId": null, "taxCategoryName": null, 
						"defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null
					},

					"addOnsDataModel": {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":null, "type":null},

					"tdsDataModel":{
						"transactionTdsId":null, "transactionId":null, "tdsAccountId":null, "tdsAccountName":null, "appliedOnAmount":null, "percentage":null, "amount":null
					},

					"transactionAddOns":[],

					"tdsDetails":{"amount":0},

					"addOnsProp":{},

					"itemsSummary":{"grossAmount":0, "grossAmountAsPerMRP":0, "addOnsItems":[], "taxValue":0, "itemsQuanity":[]},

					"transactionTypeData":null,
					"dynamicFields":{"section":null, "items":[], "accountGroupId":null, "accountGroupName":null, "ref":null},

					"dynamicFieldsAdditionalData":{},

					"customFields":[],

					"dynamicMenuItems":[],

					"gstType":null,

					"defaultTaxAddOns":[],

					"gstAddOns":[],
					"cessAddOns":null,

					"savedItemData":null,
					"isNew":true,

					"transactionTypeList":[],
					// "inventory":0,
					"draftItems":[],
					"hideEwayOption": false,
					"placeOfSupplyId":null,
					"placeOfSupplyName":null,
					"placeOfSupplyCountryId":null,
					"placeOfSupplyCountryName":null,
					// "partyGstType":null,
					"isRounded":true,
					"roundOffValue":null,
					"isRcmApplicable":false
					// "invoiceType":0
				};

				this.fn_initializeSettings();

				this.fn_getTransactionTypeList(true);
			},

			// fn_saveToLocalStorage: function(){
			// 	if(!this.unwatch){
			// 		var dataObj = {};
			// 		dataObj.type = this.toolbarTitle;//formName
			// 		dataObj.formType = "new";//eliminate
			// 		dataObj.modifiedDate = new Date();
			// 		dataObj.formId = this.formId;
			// 		dataObj.draftId = this.draftStorageId;
			// 		dataObj.uri = this.$route.path;//formPath
			// 		dataObj.dataModel = JSON.parse(JSON.stringify(this.Form));//data
			// 		dataObj.dataModel.name = this.Form.partyName ? this.Form.partyName : "no name";

			// 		localStorage.setItem(this.draftStorageId, JSON.stringify(dataObj));
			// 	}
			// 	this.unwatch = false;
			// },

			fn_menuItemClick: function(tagId, menuId, menuAction){

				this.backButtonPress = false;
				if(menuAction.indexOf('section_')!=-1){
					let sectionId = menuAction.substring(menuAction.indexOf('_')+1);
					this.fn_bindDynamicFields(sectionId);
				}
				else if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='newledger'){
					//Force save to local storage as dynamic fields need to be save in local storage
					this.fn_saveDraft(this.Form.partyName);
					this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), groupTypeId: ledgerGroupTypeId.other, ls:1, type:this.ledgerType}})
				}
				else if(menuAction=='newsupplier'){
					this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), groupTypeId: ledgerGroupTypeId.supplier, ls:1, type:"supplier"}})
				}
				else if(menuAction=='newexpensecategory'){
					this.$router.push({path:'/masters/expensecategory/items/new', query:{tagId:this.guidWeb(), groupTypeId: ledgerGroupTypeId.other, ls:1}})
				}
				else if(menuAction=='dynamicAccountField'){
					this.fn_newDynamicAccount();
				}
				else if(menuAction=='newproduct'){
					this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), inventory:0, ls:1}})
				}
				// else if(menuAction=='newproduct'){
				// 	this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), groupTypeId: productGroupTypeId.product}})
				// }
				// else if(menuAction=='newservice'){
				// 	this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), groupTypeId: productGroupTypeId.service}})
				// }
				else if(menuAction=='newListItem'){
					//Force save to local storage as dynamic fields need to be save in local storage
					this.fn_saveDraft(this.Form.partyName);
					this.$router.push({path:'/masters/lists/'+this.Form.dynamicFieldsAdditionalData.listId+'/items/new', query:{tagId:this.guidWeb(), listTitle:this.Form.dynamicFieldsAdditionalData.listName, ls:1, type:'listItem'}});
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
				else if(menuAction=='addnote'){
					this.fn_addNote();	
				}
                else if(menuAction=='camera'){
					let self = this;
					this.$root.fn_checkCameraPermission(function(){
	                   	self.fn_captureImage();
	                });
				}
                else if(menuAction=='fileManager'){
					let self = this;
					this.$root.fn_checkStoragePermission(function(){
	                   	self.fn_uploadFiles(); 
	                });
				}
				// else if(menuAction=='camera' || menuAction=='fileManager'){
				// 	let self = this;
				// 	this.$root.fn_checkStoragePermission(function(){
	            //        	menuAction=='camera' ? self.fn_captureImage() : self.fn_uploadFiles(); 
	            //     });
				// }
				else if(menuAction=='applytds'){
					this.fn_openTdsForm();
				}
				else if(menuAction=='addonsmenu'){
					this.fn_openAddOns(null, true);
				}
				// else if(menuAction=='addOns'){
				// 	this.fn_getBottomMenuAddOns();
				// }
				else if(menuAction=='adddiscount'){
					this.$router.push({path:'/addons/discounts/new', query:{tagId:this.guidWeb(), ls:1}});
				}
				else if(menuAction=='addtaxes'){
					this.$router.push({path:'/addons/taxes/new', query:{tagId:this.guidWeb(), ls:1}});
				}
				else if(menuAction=='addothercharges'){
					this.$router.push({path:'/addons/othercharges/new', query:{tagId:this.guidWeb(), ls:1}});
				}
				// else if(menuAction=='cancel'){
				// 	this.fn_openDialogCancelTransaction();
				// }
			},

			fn_newDynamicAccount: function(){
				let groupTypeId = null;
				if(this.Form.dynamicFields.accountGroupId == accountGroupIds.debtors.id)
					groupTypeId = 101;
				else if(this.Form.dynamicFields.accountGroupId == accountGroupIds.creditors.id || this.Form.dynamicFields.accountGroupId == accountGroupIds.transporter.id)
					groupTypeId = 102;
				else if(this.Form.dynamicFields.accountGroupId == accountGroupIds.brandAndDivision.id)
					groupTypeId = 104;
				else
					groupTypeId = 103;

				// setting up default account group to be selected
				let data = {};
				data.type = 'accountGroup';
				data.id = this.Form.dynamicFields.accountGroupId;
				data.name = this.Form.dynamicFields.accountGroupName;
				localStorage.setItem('newItem', JSON.stringify(data));

				this.$router.push({
					path:'/masters/accounts/ledgers/items/new', 
					query:{
						tagId:this.guidWeb(), 
						groupTypeId: groupTypeId, 
						ls:1
					}
				})
			},

			// fn_openDialogCancelTransaction: function(){
			// 	this.confirmationMessage = "Cancelled transaction cannot be revoke."
			// 	this.fn_openDialogWeb('web', 'Cancel Transaction', 'ref_dialogCancelTransaction');
			// },

			fn_openDialogPendingItemsList: function (ref) {
				this.fn_openDialogWeb('web', 'PendingItemsList', ref);
			},

			fn_openDialogReturnForm: function (ref) {
				this.fn_openDialogWeb('web', 'ReturnForm', ref);
			},

			fn_bindDynamicFields: function (sectionId) {

				this.Form.dynamicFields = {"section":null, "items":[], "additionalData":{}, "accountGroupId":null, "accountGroupName":null};

				let itemIndex = this.Form.customFields.findIndex(item=>{
					return item.section.sectionId == sectionId;
				});

				this.Form.dynamicFields.section = this.Form.transactionTypeData.transactionSections.find(item=>{
					return sectionId == item.sectionId;
				});

				this.Form.dynamicFields.items = this.Form.transactionTypeData.transactionTypeFields.filter(item=>{
					if(sectionId == item.sectionId){
						item.additionalData = typeof(item.additionalData) == 'string' ? JSON.parse(item.additionalData) : item.additionalData;
						item.value = null;
						item.listItemId = null;
						item.accountLedgerId = null;

						if(item.fieldType == 'yes/no'){
							item.value = item.additionalData.defaultValue;
						}

						if(item.fieldType == 'choice'){
							item.value = item.additionalData.defaultChoice;
							// item.value = item.additionalData.choices[0];
						}

						// if(item.fieldType == 'dateTime'){
						// 	item.value = new Date();
						// }
						
						return true;
					}
				});

				if(itemIndex!=-1){

					for(let i=0; i<this.Form.dynamicFields.items.length; i++){

						let defaultField = this.Form.dynamicFields.items[i];

						for(let j=0; j<this.Form.customFields[itemIndex].items.length; j++){

							let existingField = this.Form.customFields[itemIndex].items[j];

							if(defaultField.fieldId == existingField.fieldId){
								defaultField.value = existingField.value;

								if(defaultField.fieldType == 'linkedItem'){
									defaultField.listItemId = existingField.listItemId;
								}
								else if(defaultField.fieldType == 'accountItem'){
									defaultField.accountLedgerId = existingField.accountLedgerId;
								}

							}

						}

					}

				}
				

				console.log(JSON.stringify(this.Form.dynamicFields));

				this.fn_openDialogDynamicFields();
			},

			fn_openDialogDynamicFields: function () {
				this.fn_openDialogWeb('web', 'DynamicFields', 'ref_dialogDynamicFields');
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;
				
				if(this.Form.transactionData.transactionId){
					this.fn_get(this.Form.transactionData.transactionId);
				}
				else{
					this.fn_clearForm();
				}

				// if(localStorage.getItem(this.draftStorageId)){
				// 	localStorage.removeItem(this.draftStorageId);
				// 	this.snackbar = true;
				// 	this.snackbar_msg = "Item deleted from draft";
				// }

				this.fn_removeDraft(this.draftStorageId);
				
			},

			fn_initializeSettings: function () {
				let self = this;
				transactionForms.filter(item => {
					if(item.id == this.settings.transactionTypeId){
						this.unwatch = true;
						this.toolbarTitle = item.title;
						this.Form.transactionData.transactionListId = this.settings.transactionTypeId;
						// this.Form.transactionData.transactionDate = new Date();
						// this.Form.transactionData.refDate = new Date();

						if(new Date().getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
							this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(this.$root.CurrentBusiness.OpeningDate);
							// this.Form.transactionData.refDate = this.$root.fn_getLocalDateFormat(this.$root.CurrentBusiness.OpeningDate);
						}
						else{
							this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat();
							// this.Form.transactionData.refDate = this.$root.fn_getLocalDateFormat();
						}
					}
				});

				let typeId = this.settings.transactionTypeId;

				this.fn_getDefaultGstAddOns();
				this.fn_getDefaultCessAddOns();
				this.fn_getTaxCategories();
			},

			fn_addNote: function () {
				this.$refs['ref_dialogNote'].noteValue = this.Form.transactionData.notes;
				this.fn_openDialogWeb('web', 'Note', 'ref_dialogNote');
				setTimeout(function(){
					let noteField = document.getElementById('noteField');
					noteField.focus();
				});
			},

			fn_saveNote: function () {
				this.Form.transactionData.notes = this.$refs['ref_dialogNote'].noteValue;
				this.fn_closeDialog();
			},

			fn_showWebView: function () {
				var viewObject = {};

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			// fn_setFormDataFromLocalStorage: function () {
			// 	if(localStorage.getItem(this.draftStorageId)){
			// 		var formData = JSON.parse(localStorage.getItem(this.draftStorageId));
			// 		this.unwatch = true;
			// 		this.Form = JSON.parse(JSON.stringify(formData.dataModel));

			// 		if((this.$route.query && this.$route.query.draft) || (this.$route.params && this.$route.params.tagId)){
			// 			this.loadedFromDraft = true;
			// 			this.Form.isNew ? this.fn_getTransactionTypeData(this.Form.transactionTypeFormId, null, false, 'draft') : '';
			// 		}
			// 	}
			// },

			fn_refreshTransactionTypeData: function(transactionTypeData){

				this.fn_bindTransactionNumber();

				if(this.Form.partyId && !transactionTypeData.isAllPartySelected){
					this.fn_validateParty(transactionTypeData.transactionParties);
				}

				let self = this;

				self.Form.productDataModel.addOnsItems = [];

				transactionTypeData.transactionTypeAddOns.forEach(function (item) {
					if(item.type==0){
	          			self.Form.productDataModel.addOnsItems.push(JSON.parse(JSON.stringify(item)));
					}
	          	});

	          	for(let i=0; i<this.Form.items.length; i++){

	          		let addOnsItems = [];

					for(let j=0; j<transactionTypeData.transactionTypeAddOns.length; j++){

						if(transactionTypeData.transactionTypeAddOns[j].type==0){

							for(let k=0; k<this.Form.items[i].addOnsItems.length; k++){
								if(this.Form.items[i].addOnsItems[k].addOnsId == transactionTypeData.transactionTypeAddOns[j].addOnsId){
									addOnsItems.push(this.Form.items[i].addOnsItems[k]);
								}
							}

						}

					}

					this.Form.items[i].addOnsItems = JSON.parse(JSON.stringify(addOnsItems));
				}

				// binding dynamic field options to the menu
				// this.Form.dynamicMenuItems = [];

				// if(transactionTypeData && transactionTypeData.transactionSections.length){
				// 	transactionTypeData.transactionSections.forEach(function (item) {
				// 		let obj = {};
				// 		obj.MenuID = null;
				// 		obj.Icon = null;
				// 		obj.Text = item.sectionName;
				// 		obj.Action = 'section_'+item.sectionId;
				// 		obj.sectionId = item.sectionId;
				// 		obj.hideOption = false;
				// 		self.Form.dynamicMenuItems.push(obj);
				// 	});
				// }

				//inserting eway bill details to transaction type fields manually
				this.fn_bindEwayBillSection();

				// this.hideLoading();
				this.loading = false;
			},

			fn_setNewItem: function(){
				let itemData = null;

				if(localStorage.getItem('newItem')){

					itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "transactionTypeForm":
					    	this.fn_setTransactionType({transactionTypeFormId:itemData.id, name:itemData.name});
					        break;
					    case "supplier":
					    	this.fn_updateSupplier(itemData.id, itemData.name, false);
					        break;
					    case "product":
							this.fn_setNewProduct(itemData.id, itemData.name, false);
					    	// this.$refs['ref_dialogProduct'].fn_updateProduct(itemData.id, itemData.name, false);
					        break;
					    case "newTaxCategory":
					    	this.fn_updateTaxCategory(itemData, true);
					        break;
					    case "discounts":
					    case "taxes":
					    case "otherCharges":
							this.fn_setNewAddOns(itemData.id, itemData.name, false);
					    	// this.$refs['ref_dialogAddOns'].fn_updateAddOns(itemData.id, itemData.name, false);
					        break;
					    case "listItem":
					    	this.$refs['ref_dialogDynamicFields'].fn_updateLinkedItem(itemData.id, itemData.name, false)
					        break;
					    case "expenseLedger":
					    	this.fn_updateAccountLedger(itemData.id, itemData.name, false);
					    	this.ledgerType = 'ledger';
					        break;
					    case "ledger":
					    	this.$refs['ref_dialogDynamicFields'].fn_updateAccountLedger(itemData.id, itemData.name, false, null, itemData.accountGroupId)
					        break;
					    case "expenseCategory":
					    	this.fn_updateExpenseCategory(itemData.id, itemData.name, false)
					        break;
					    case "ledger_other":
					    	this.fn_getPaymentGroups();
					        break;
					        
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				if(this.$route.query && this.$route.query.dt && !itemData){
					this.fn_updateSupplier(this.$route.query.id, this.$route.query.name, false);
				}
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){

			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_transaction_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
				// !this.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive") ?  this.fn_checkTransactionCount() : '';
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_transaction_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			// !this.$root.CurrentBusiness.DataDrive ?  this.fn_checkTransactionCount() : '';
			// if(this.$root.CurrentBusiness.DataDrive && this.Form.isNew){
			// 	this.fn_checkTransactionCount(()=>{
			// 		if(this.transactionCount>10){
			// 			this.fn_openDialogDriveSetup();
			// 		}
			// 	})
			// }

			var formsArray = [];
			if(localStorage.getItem('expenseforms')){
				formsArray = JSON.parse(localStorage.getItem('expenseforms'));
			}
			formsArray.push(this.formId);
			localStorage.setItem('expenseforms', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}
			// dialogjs.fn_checkAndShowOpenDialogs(this);

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				this.unwatch = true;
				// this.fn_setFormDataFromLocalStorage();
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);

			            if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			              // self.loadedFromDraft = true;

			             	if(self.Form.isNew){
								self.fn_getTransactionTypeData(self.Form.transactionTypeFormId, null, false, 'draft');
							}
							else{
								self.loading = false;
							}

			              // self.Form.isNew ? self.fn_getTransactionTypeData(self.Form.transactionTypeFormId, null, false, 'draft') : '';
			            }
			            else{
			            	self.loading = false;
			            }

					}

		            self.$route.query.tagId ? self.fn_checkDraftItems(self.toolbarTitle) : '';

				});
			}

			this.fn_initializeSettings();

			// posting metrics on open
			this.fn_isDraft(isDraft=>{
				if(!isDraft){
					let postObj = {"eventName":this.toolbarTitle.toLowerCase() + '_open',"eventData":[{"eventKey":"form_type","eventValue":this.$route.params && this.$route.params.tagId ? "edit" : "new"}]}
        			this.$root.fn_postMetrics(postObj);
				}
			})

			// let formElement = document.getElementsByClassName("form-element")[0];

			// formElement.addEventListener("submit", function(e){
			//     e.preventDefault();
			// });

			// this.$eventHub.$on('closedialog', this.fn_closeDialog);

			// this.$eventHub.$on('newLedger', response => {
			// 	this.Form.partyId = response.id;
			// 	this.Form.partyName = response.name;
			// });

			setTimeout(function(){self.fn_setNewItem()},300);

			this.fn_setDraftData('Transaction', this.toolbarTitle);
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
				}

				//edit from list view
		  		else if(to.params && to.params.tagId){
		  			itemId = to.params.tagId;
		  		}

		  		//checking if draft exist
		  		vm.fn_isDraft(function(isDraft){
		  			if(itemId && !isDraft){
		  				vm.fn_get(itemId);
		  			}

		  			let setTFT = !itemId && !isDraft;

		  			vm.fn_getTransactionTypeList(setTFT);
		  		})

		  	})
		},
		beforeRouteUpdate (to, from, next) {
			this.enableToolbar();
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('expenseforms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
	    beforeRouteLeave (to, from, next) {

			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
				if(this.backButtonPress){
					if(this.transactionCount >= 10 && this.$refs['ref_dialogDriveAlert'].backupAlertSheet){
						this.fn_draftAction(true, 1);
						next(true);
					}
					else{
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						next(false);
					}
				}
				else{
					localStorage.removeItem("SetDataDrive");
					next(true);
				}
			}
			else{
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData('expenseforms', function(){
						localStorage.removeItem("SetDataDrive");
						next();
					})
				}
			}

			// if(this.$refs['ref_dialogPermission'].dialog_permission){
			// 	this.$refs['ref_dialogPermission'].dialog_permission = false;
			// 	next(false);
			// }
			// else{
			// 	var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			// 	if(dialogData && dialogData.length){

			// 		if(this.backButtonPress){
			// 			dialogjs.fn_checkAndCloseOpenDialogs(this);
			// 			next(false);
			// 		}
			// 		else{
			// 			localStorage.removeItem("SetDataDrive");
			// 			next(true);
			// 		}
			// 	}
			// 	else{
			// 		if(this.fn_showDialogDiscard()){
			// 			this.fn_openDialogDiscard();
			// 			next(false);
			// 		}
			// 		else{
			// 			this.fn_clearData('expenseforms', function(){
			// 				localStorage.removeItem("SetDataDrive");
			// 				next();
			// 			})
			// 		}
			// 	}
			// }
	    },
	    computed:{
	  		netAmount: function () {
	    		let netAmount = 0;
	    		let grossAmount = 0;
	    		let grossAmountAsPerMRP = 0;
	    		let taxValue = 0;	
	    		let cessValue = 0;
	    		let taxableValue = 0;
	    		let self = this;

	    		this.Form.itemsSummary.addOnsItems = [];
	    		this.Form.itemsSummary.itemsQuanity = [];

	    		if(this.Form.items.length){

	    			this.Form.items.forEach(function (item) {
		    			grossAmount += item.grossAmount;
		    			grossAmountAsPerMRP += item.grossAmountAsPerMRP;

		    			taxableValue += item.taxableValue;

		    			item.addOnsItems.forEach(function (addOnsItem) {

		    				if(addOnsItem.value!==null && addOnsItem.value!==''){
		    					let value = addOnsItem.value;

			    				let itemIndex = self.Form.itemsSummary.addOnsItems.findIndex(onsItem=>{
			    					return onsItem.addOnsId == addOnsItem.addOnsId;
			    				})

			    				if(itemIndex!=-1){
			    					let addOnsSum = self.Form.itemsSummary.addOnsItems[itemIndex].value;
			    					addOnsSum += value;
			    					self.Form.itemsSummary.addOnsItems[itemIndex].value = self.roundUpto2Decimals(addOnsSum);
			    				}
			    				else{
			    					let obj = {};
			    					obj.addOnsId = addOnsItem.addOnsId;
			    					obj.name = addOnsItem.name;
			    					obj.value = addOnsItem.value;
			    					obj.mode = addOnsItem.mode;
			    					obj.nature = addOnsItem.nature;
			    					self.Form.itemsSummary.addOnsItems.push(obj);
			    				}
		    				}

		    			})

		    			if(self.Form.taxMode!=null){
		    				taxValue += item.taxAmount;
		    				cessValue += item.cessAmount;
		    			}

		    			netAmount += item.netAmount;

		    			item.productVariants.forEach(function (variantItem) {

		    				let qty = variantItem.qty ? variantItem.qty : 0;

		    				console.log(variantItem);

		    				let itemIndex = self.Form.itemsSummary.itemsQuanity.findIndex(vItem=>{
		    					console.log(vItem);
		    					return vItem.unitId == variantItem.unitId && vItem.packQuantity == variantItem.packQuantity;
		    				});

		    				if(itemIndex!=-1){
		    					self.Form.itemsSummary.itemsQuanity[itemIndex].qty += qty;
		    				}
		    				else{
		    					let vObj = {};
			    				vObj.unitId = variantItem.unitId;
			    				vObj.unitName = variantItem.unitName;
			    				vObj.packQuantity = variantItem.packQuantity;
			    				vObj.qty = qty;
			    				self.Form.itemsSummary.itemsQuanity.push(vObj);
		    				}
		    			})

		    		});
	    		}
	    		else{
	    			netAmount += this.Form.expenseData.amount;
	    			taxableValue = this.Form.expenseData.amount;
	    		}

	    		// if(!this.Form.inventory){
	    		// 	netAmount += this.Form.expenseData.amount;
	    		// 	taxableValue = this.Form.expenseData.amount;
	    		// }
	    		// else{
	    		// 	this.Form.items.forEach(function (item) {
		    	// 		grossAmount += item.grossAmount;
		    	// 		grossAmountAsPerMRP += item.grossAmountAsPerMRP;

		    	// 		taxableValue += item.taxableValue;

		    	// 		item.addOnsItems.forEach(function (addOnsItem) {

		    	// 			if(addOnsItem.value!==null && addOnsItem.value!==''){
		    	// 				let value = addOnsItem.value;

			    // 				let itemIndex = self.Form.itemsSummary.addOnsItems.findIndex(onsItem=>{
			    // 					return onsItem.addOnsId == addOnsItem.addOnsId;
			    // 				})

			    // 				if(itemIndex!=-1){
			    // 					let addOnsSum = self.Form.itemsSummary.addOnsItems[itemIndex].value;
			    // 					addOnsSum += value;
			    // 					self.Form.itemsSummary.addOnsItems[itemIndex].value = self.roundUpto2Decimals(addOnsSum);
			    // 				}
			    // 				else{
			    // 					let obj = {};
			    // 					obj.addOnsId = addOnsItem.addOnsId;
			    // 					obj.name = addOnsItem.name;
			    // 					obj.value = addOnsItem.value;
			    // 					obj.mode = addOnsItem.mode;
			    // 					obj.nature = addOnsItem.nature;
			    // 					self.Form.itemsSummary.addOnsItems.push(obj);
			    // 				}
		    	// 			}

		    	// 		})

		    	// 		if(self.Form.taxMode!=null){
		    	// 			taxValue += item.taxAmount;
		    	// 			cessValue += item.cessAmount;
		    	// 		}

		    	// 		netAmount += item.netAmount;

		    	// 		item.productVariants.forEach(function (variantItem) {

		    	// 			let qty = variantItem.qty ? variantItem.qty : 0;

		    	// 			console.log(variantItem);

		    	// 			let itemIndex = self.Form.itemsSummary.itemsQuanity.findIndex(vItem=>{
		    	// 				console.log(vItem);
		    	// 				return vItem.unitId == variantItem.unitId && vItem.packQuantity == variantItem.packQuantity;
		    	// 			});

		    	// 			if(itemIndex!=-1){
		    	// 				self.Form.itemsSummary.itemsQuanity[itemIndex].qty += qty;
		    	// 			}
		    	// 			else{
		    	// 				let vObj = {};
			    // 				vObj.unitId = variantItem.unitId;
			    // 				vObj.unitName = variantItem.unitName;
			    // 				vObj.packQuantity = variantItem.packQuantity;
			    // 				vObj.qty = qty;
			    // 				self.Form.itemsSummary.itemsQuanity.push(vObj);
		    	// 			}
		    	// 		})

		    	// 	});
	    		// }
	    		

	    		this.Form.itemsSummary.grossAmount = this.roundUpto2Decimals(grossAmount);
				this.Form.itemsSummary.grossAmountAsPerMRP = this.roundUpto2Decimals(grossAmountAsPerMRP);
				this.Form.itemsSummary.taxValue = this.roundUpto2Decimals(taxValue); 
				this.Form.itemsSummary.cessValue = this.roundUpto2Decimals(cessValue); 

				this.Form.transactionData.taxableValue = taxableValue;

	    		console.log(JSON.stringify(this.Form.itemsSummary));

	    		
	    		// if((this.Form.isRcmApplicable && this.Form.isItcEligible) || this.Form.isRcmApplicable){
	    		// 	return this.roundUpto2Decimals(netAmount - taxValue - cessValue);
	    		// }
	    		// else{
	    		// 	return this.roundUpto2Decimals(netAmount);;
	    		// }

	    		// putting these hack in case of rcm update just to recompute values
    			if(this.Form.isRcmApplicable){
    				return this.roundUpto2Decimals(netAmount);	
    			}
    			else{
    				return this.roundUpto2Decimals(netAmount);	
    			}
	    		// return this.roundUpto2Decimals(netAmount);
	    	},
	    	totalAmount: function () {
	    		let grossAmount = 0;
	    		let grossAmountAsPerMRP = 0;
	    		let netAmount = this.netAmount;
	    		if(this.Form.items.length){
	    			grossAmount = this.Form.itemsSummary.grossAmount;
	    			grossAmountAsPerMRP = this.Form.itemsSummary.grossAmountAsPerMRP
	    		}
	    		else{
	    			grossAmount = this.Form.netInvoiceValue;
	    			grossAmountAsPerMRP = this.Form.netInvoiceValue;
	    		}
	    		// let grossAmount = this.Form.itemsSummary.grossAmount;
	    		// let grossAmountAsPerMRP = this.Form.itemsSummary.grossAmountAsPerMRP;
	    		// let netAmount = this.netAmount;

	    		let totalAmount = 0;

	    		let self = this;

	    		let addOnsTotalValue = 0;

	    		this.Form.transactionAddOns.forEach(function (item) {

					let applicableAmount = 0;
					let addOnsValue = 0;

					//on net value
					if(item.appliedOn == 0){
						applicableAmount = netAmount;
					}//value of goods
					else if(item.appliedOn == 1){
						applicableAmount = grossAmount;
					}//on mrp
					else{
						applicableAmount = grossAmountAsPerMRP;
					}

					//of value or percentage
					if(item.mode){//value
						addOnsValue = item.value;
					}
					else{//percentage
						if(item.percentage!==null && item.percentage!==''){
							addOnsValue = (applicableAmount*item.percentage)/100;
							item.value = self.roundUpto2Decimals(addOnsValue);
						}
						else if(item.value!==null && item.value!==''){
							addOnsValue = item.value;
						}
					}

					addOnsValue = self.roundUpto2Decimals(addOnsValue);

					let isTaxLedger = false;
					if(fixedGstAddOns.CGST.id == item.addOnsId || fixedGstAddOns.SGST.id == item.addOnsId || fixedGstAddOns.UTGST.id == item.addOnsId || fixedGstAddOns.IGST.id == item.addOnsId || fixedCessAddOns.CESS.id == item.addOnsId){
						isTaxLedger = true;
					}

					//Final calculation
					if(item.adjustInTotal){
						if(item.nature==0){
							// if(self.Form.isRcmApplicable){
							// if((!self.Form.isRcmApplicable && !self.Form.isItcEligible) || (self.Form.isRcmApplicable && self.Form.isItcEligible) || self.Form.isRcmApplicable){
							if(((self.Form.isRcmApplicable && self.Form.isItcEligible) || self.Form.isRcmApplicable) && isTaxLedger){
								addOnsTotalValue += item.addOnsType != 2 ? addOnsValue : 0;
							}
							else{
								addOnsTotalValue += addOnsValue;
							}
						}
						else{
							addOnsTotalValue -= addOnsValue;
						}
					}

				});

	    		totalAmount = this.netAmount + addOnsTotalValue - this.Form.tdsDetails.amount;

				return this.roundUpto2Decimals(totalAmount);
	    	},
	    	// roundedAmount: function(){
	    	// 	if(this.Form.isRounded){
	    	// 		return Math.round(this.totalAmount);	
	    	// 	}
	    	// 	else{
	    	// 		return this.totalAmount;
	    	// 	}
	    	// },
	    	// roundOff: function(){
	    	// 	return this.roundUpto2Decimals(this.roundedAmount - this.totalAmount);
	    	// },
	    	roundOff: function(){
	    		let roundAmount = null;
	    		if(this.Form.isRounded){
	    			roundAmount = Math.round(this.totalAmount);
	    		}
	    		else{
	    			this.Form.roundOffValue = null;
	    			roundAmount = this.totalAmount;
	    		}

	    		if(this.Form.roundOffValue){
	    			return this.Form.roundOffValue;
	    		}
	    		else{
	    			// return this.roundUpto2Decimals(this.roundedAmount - this.totalAmount);
	    			return this.roundUpto2Decimals(roundAmount - this.totalAmount);
	    		}
	    	},
	    	roundedAmount: function(){
	    		return this.roundUpto2Decimals(this.totalAmount + this.roundOff);
	    	},
	    	expandCustomFields: function(){
	    		let expantionModel = [];
	    		for(let i in this.Form.customFields){
	    			expantionModel.push(true);
	    		}
	    		return expantionModel;
	    	},	
	    	// minTransactionDate: function(){
	    	// 	if(!this.Form.isNew){
	    	// 		let defaultMinDate = new Date(this.$root.minDateSelection);
	    	// 		let month = ("0" + (defaultMinDate.getMonth() + 1)).slice(-2);
	    	// 		let date = defaultMinDate.getDate();
	    	// 		return this.fn_getFiscalYear(this.Form.transactionData.transactionDate) + "-" + month + "-" + date;
	    	// 	}
	    	// 	else{
	    	// 		return null;
	    	// 	}
	    	// },
	    	// maxTransactionDate: function(){
	    	// 	if(!this.Form.isNew){
	    	// 		return (this.fn_getFiscalYear(this.Form.transactionData.transactionDate)+1) + "-03-31";
	    	// 	}
	    	// 	else{
	    	// 		return null;
	    	// 	}
	    	// },
	    	otherChargeItems: function(){
	    		let items = [];
	    		items = this.Form.transactionAddOns.filter(item=>{
	    			return item.addOnsType == 3;
	    		});
	    		return items;
	    	},
	    	discountItems: function(){
	    		let items = [];
	    		items = this.Form.transactionAddOns.filter(item=>{
	    			return item.addOnsType == 1;
	    		});
	    		return items;
	    	},
	    	taxItems: function(){
	    		let items = [];
	    		items = this.Form.transactionAddOns.filter(item=>{
	    			return item.addOnsType == 2;
	    		});
	    		return items;
	    	},
	    	splitPaymentTotal: function(){
	    		let splitPaymentTotal = 0;
	    		if(this.Form.splitPayment){
	    			for(let i=0; i<this.Form.paymentOptions.length; i++){
	    				splitPaymentTotal += this.Form.paymentOptions[i].amount;
	    			}
	    			return this.roundUpto2Decimals(splitPaymentTotal);
	    		}
	    		else{
	    			return this.roundedAmount;
	    		}
	    	},
	    	totalQty: function(){
	    		let totalQty = 0;
	    		if(this.Form.itemsSummary && this.Form.itemsSummary.itemsQuanity && this.Form.itemsSummary.itemsQuanity.length){
	    			for(let i=0; i<this.Form.itemsSummary.itemsQuanity.length; i++){
		    			totalQty += this.Form.itemsSummary.itemsQuanity[i].qty;
		    		}	
	    		}
	    		return totalQty;
	    	}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/expense/form.vue